import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu';
import type {
  TranslationFunction,
  MakeKeyFunction,
} from 'src/types/language-support';
import moment from 'moment';
import type {
  JOB_INFORMATION,
  JOB_LISTS,
  JOB_CUSTOM_FIELDS,
  MILESTONES,
  INTERVIEW_FLOW,
  JOB_STAGES,
  JOB_HIRING_ROUNDS,
  JOB_HIRING_TEAM,
  STAGE_REMOVE_RESPONSE,
  JOB_LOCATION,
  USER_BASE_INFO,
  PENDING_APPROVALS,
  CompanyInfoJdGen,
  ApprovalObject,
  EmployeeRole,
  JOB_HIRING_STEPS,
  JOB_SCORE_CARDS,
  SCORE_CARD_CONFIG_RESPONSE,
  FEEDBACK_CONFIG_RESPONSE,
  STEP_QUESTIONNAIRE_SECTIONS_RESPONSE,
  VALIDATED_OBJECT,
  CandidateList,
  ApprovalStatus,
  Tag,
  HIERARCHY_LEVEL,
  OFFERS_CANDIDATE_INFO,
  CANDIDATE_JOB_STEPS,
  CANDIDATE_RESUME_PARSING_PAYLOAD,
  RESUME_PARSING,
  CANDIDATE_FEEDBACK,
  INTERVIEW_SCHEDULE,
  HM_EXPERIENCE_SURVEY,
  Candidate,
  ApplicantList,
  ApplicantListFilterMetadata,
  customMenuOption,
  MicrosoftLoginResponse,
  InternalFormConfig,
  PartialCandidate,
  AI_SUMMARY,
  EVALUATION,
  VOICE_CALL_RESPONSE,
  VOICE_PHONE_NUMBERS_AND_BOTS,
} from 'src/types/crm';

// action constants
export const UPDATE_JOB_INFORMATION = 'update-job-information';
export const UPDATE_APPROVALS = 'update-approvals';
export const GET_JOB_LOCATIONS = 'get-job-location';
export const GET_USER_INFO = 'get-base-info';
export const GET_PENDING_APPROVALS = 'get-pending-approvals';
export const GET_JOB_GRADES = 'get-job-grade';
export const GET_JOB_DEPARTMENTS = 'get-job-department';
export const GET_CUSTOM_JOB_FIELDS = 'get-custom-job-fields';
export const GET_HIRING_MILESTONES = 'get-milestones';
export const GET_JOB_INTERVIEW_FLOW = 'get-job-interview-flow';
export const GET_JOB_INTERVIEW_FLOW_BY_CANDIDATE =
  'get-job-interview-flow-by-candidate';
export const GET_JOB_HIRING_STAGES = 'get-job-hiring-stages';
export const CREATE_HIRING_ROUNDS = 'create-hiring-rounds';
export const GET_HIRING_TEAM = 'get-hiring-team';
export const REMOVE_HIRING_STAGE = 'remove-hiring-stage';
export const UPDATE_COMPANY_INFO_JD_GENERATE = 'update-company-jd-generate';
export const GET_EMPLOYEE_ROLE = 'get-employee-role';
export const GET_JOB_STEPS = 'get-job-steps';
export const GET_CANDIDATE_JOB_STEPS = 'get-candidate-job-steps';
export const GET_JOB_SCORE_CARDS = 'get-job-score-cards';
export const GET_SCORE_CARD_CONFIG = 'get-scorecard-config';
export const UPDATE_SCORE_CARD_CONFIG = 'update-scorecard-config';
export const GET_FEEDBACK_CONFIG = 'get-feedback-config';
export const GET_STEP_QUESTIONNAIRE_SECTIONS = 'get-step-questionnaire';
export const POST_INTERNAL_FORM_CONFIG_EMPLOYEE =
  'post_internal_form_config_employee';
export const POST_INTERNAL_FORM_CONFIG_SEND_EMAIL_STATUS =
  'post_internal_form_config_send_email_status';
export const POST_INTERNAL_FORM_CONFIG_FORM_SELECTION =
  'post_internal_form_config_form_selection';
export const GET_APPROVAL_REQUEST_TIME = 'get-approval-request-time';
export const SELECTED_QUESTIONNAIRE_SECTION = 'selected_questionnaire_section';
export const GET_JOB_MATCHES = 'get-job-matches';
export const UPDATE_APPROVAL_STATUS = 'update-approval-status';
export const GET_TAGS = 'get-tags';
export const EDIT_TAG = 'edit-tag';
export const DELETE_TAG = 'delete-tag';
export const ADD_TAGS_TO_CANDIDATE = 'add-tags-to-candidate';
export const GET_HIERARCHY_LEVELS = 'get-hierarchy-levels';
export const ADD_TAG = 'add-tag';
export const UPDATE_SELECTED_PENDING_OFFER_CANDIDATE =
  'update-selected-candidate';
export const UPDATE_APPLICANT_INFORMATION = 'update-applicant-information';
export const UPDATE_CANDIDATE_INTERVIEW_SCHEDULES =
  'update-candidate-interview-schedules';
export const UPDATE_CANDIDATE_HM_EXPERIENCE_SURVEYS =
  'update-candidate-hm-experience-surveys';
export const UPDATE_CANDIDATE_FEEDBACKS = 'update-candidate-feedbacks';
export const UPDATE_COMPLETED_CANDIDATE_FEEDBACKS =
  'update-completed-candidate-feedbacks';
export const UPDATE_COMPLETED_INTERVIEW_SCHEDULES =
  'update-completed-interview-schedules';
export const UPDATE_COMPLETED_HM_EXPERIENCE_SURVEYS =
  'update-completed-hm-experience-surveys';
export const GET_INTERVIEWS_INFO = 'get-interviews-info';
export const CRM_CANDIDATE_PARSING = 'crm-candidate-parsing';
export const GET_APPLICANT_LIST = 'get-applicant-list';
export const GET_APPLICANT_LIST_OF_STAGE = 'get-applicant-list-of-stage';
export const GET_APPLICANT_LIST_FILTER_METADATA =
  'get-applicant-list-filter-metadata';
export const GET_APPLICANT_DETAILS = 'get-applicant-details';
export const GET_CANDIDATE_LIST = 'get-candidate-list';
export const MICROSOFT_LOGIN_SUCCESS = 'microsoft-login-success';
export const UPDATE_INTERNAL_FORM_CONFIG = 'update-internal-form-config';
export const GET_UNTRIED_COUNT = 'get-untried-count';
export const OPTIMISTIC_MOVE_CANDIDATE_TO_STAGE =
  'optimistic-move-candidate-to-stage';
export const REVERT_OPTIMISTIC_MOVE_CANDIDATE =
  'revert-optimistic-move-candidate';
export const OPTIMISTIC_BULK_MOVE_CANDIDATES_TO_STAGE =
  'optimistic-bulk-move-candidates-to-stage';
export const REVERT_OPTIMISTIC_BULK_MOVE_CANDIDATES =
  'revert-optimistic-bulk-move-candidates';
export const ADD_CANDIDATE_TO_STAGE = 'add-candidate-to-stage';
export const UPDATE_OVERVIEW_DATA = 'update-overview-data';
export const UPDATE_VOICE_PHONE_NUMBERS_AND_BOTS =
  'update-voice-phone-numbers-and-bots';
export const RESET_APPLICANT_LIST_OF_STAGE = 'reset-applicant-list-of-stage';
export const UPDATE_APPLICANT_LIST_OF_STAGE_BY_ID =
  'update-applicant-list-of-stage-by-id';
export const UPDATE_EVALUATION_FORM_DRAFT = 'update-evaluation-form-draft';
export const FLUSH_EVALUATION_FORM_DRAFT = 'flush-evaluation-form-draft';

//action types

export type UpdateVoicePhoneNumbersAndBotsAction = {
  type: typeof UPDATE_VOICE_PHONE_NUMBERS_AND_BOTS;
  payload: VOICE_PHONE_NUMBERS_AND_BOTS;
};

export type UpdateOverviewDataAction = {
  type: typeof UPDATE_OVERVIEW_DATA;
  payload: {
    aiSummary: AI_SUMMARY;
    evaluation: EVALUATION;
    voiceCallInfo: VOICE_CALL_RESPONSE;
  };
};

export type UpdateJobInformationAction = {
  type: typeof UPDATE_JOB_INFORMATION;
  payload: JOB_INFORMATION;
};

export type UpdateApplicantInformationAction = {
  type: typeof UPDATE_APPLICANT_INFORMATION;
  payload: Candidate; //HERE;
};

export type UpdateCandidateFeedbacksAction = {
  type: typeof UPDATE_CANDIDATE_FEEDBACKS;
  payload: CANDIDATE_FEEDBACK[];
};

export type UpdateCandidateInterviewSchedulesAction = {
  type: typeof UPDATE_CANDIDATE_INTERVIEW_SCHEDULES;
  payload: INTERVIEW_SCHEDULE[];
};

export type UpdateCandidateHmExperienceSurveysAction = {
  type: typeof UPDATE_CANDIDATE_HM_EXPERIENCE_SURVEYS;
  payload: HM_EXPERIENCE_SURVEY[];
};

export type UpdateCompletedCandidateFeedbacksAction = {
  type: typeof UPDATE_COMPLETED_CANDIDATE_FEEDBACKS;
  payload: CANDIDATE_FEEDBACK[];
};

export type UpdateCompletedInterviewSchedulesAction = {
  type: typeof UPDATE_COMPLETED_INTERVIEW_SCHEDULES;
  payload: INTERVIEW_SCHEDULE[];
};

export type UpdateCompletedHmExperienceSurveysAction = {
  type: typeof UPDATE_COMPLETED_HM_EXPERIENCE_SURVEYS;
  payload: HM_EXPERIENCE_SURVEY[];
};

type ValidationField = {
  errorText: string;
};

type ValidatedObject = {
  [key: string]: ValidationField;
};
export type UpdateApprovals = {
  type: typeof UPDATE_APPROVALS;
  payload: Array<ApprovalObject>;
};

export type UpdateApprovalStatusForJob = {
  type: typeof UPDATE_APPROVAL_STATUS;
  payload: ApprovalStatus;
};

export type RequestApprovalTime = {
  type: typeof GET_APPROVAL_REQUEST_TIME;
  payload: string;
};

export type GetJobGradeListAction = {
  type: typeof GET_JOB_GRADES;
  payload: JOB_LISTS[];
};

export type GetJobLocationListAction = {
  type: typeof GET_JOB_LOCATIONS;
  payload: JOB_LOCATION[];
};

export type GetUserInfoAction = {
  type: typeof GET_USER_INFO;
  payload: USER_BASE_INFO;
};

export type GetPendingApprovals = {
  type: typeof GET_PENDING_APPROVALS;
  payload: PENDING_APPROVALS;
};

export type GetJobDepartmentListAction = {
  type: typeof GET_JOB_DEPARTMENTS;
  payload: JOB_LISTS[];
};

export type GetHiringMilestineAction = {
  type: typeof GET_HIRING_MILESTONES;
  payload: MILESTONES[];
};
export type GetCustomJobFiledsAction = {
  type: typeof GET_CUSTOM_JOB_FIELDS;
  payload: JOB_CUSTOM_FIELDS[];
};

export type GetJobInterviewFlowAction = {
  type: typeof GET_JOB_INTERVIEW_FLOW;
  payload: INTERVIEW_FLOW;
};

export type GetJobStageAction = {
  type: typeof GET_JOB_HIRING_STAGES;
  payload: JOB_STAGES;
};

export type CreateHiringRoundsAction = {
  type: typeof CREATE_HIRING_ROUNDS;
  payload: JOB_HIRING_ROUNDS;
};

export type GetHiringTeamAction = {
  type: typeof GET_HIRING_TEAM;
  payload: JOB_HIRING_TEAM;
};

export type RemoveHiringStageAction = {
  type: typeof REMOVE_HIRING_STAGE;
  payload: STAGE_REMOVE_RESPONSE;
};

export type GetJobInterviewFlowByCandidateAction = {
  type: typeof GET_JOB_INTERVIEW_FLOW_BY_CANDIDATE;
  payload: {
    candidateId: string;
    interviewFlow: INTERVIEW_FLOW;
  };
};
export type UpdateCompanyInfoJdGenerateAction = {
  type: typeof UPDATE_COMPANY_INFO_JD_GENERATE;
  payload: CompanyInfoJdGen;
};

export type GetEmployeeRoleAction = {
  type: typeof GET_EMPLOYEE_ROLE;
  payload: EmployeeRole[];
};

export type GetJobStepsAction = {
  type: typeof GET_JOB_STEPS;
  payload: JOB_HIRING_STEPS[];
};

export type GetJobScoreCardAction = {
  type: typeof GET_JOB_SCORE_CARDS;
  payload: JOB_SCORE_CARDS;
};

export type GetScoreCardConfigAction = {
  type: typeof GET_SCORE_CARD_CONFIG;
  payload: SCORE_CARD_CONFIG_RESPONSE[];
};

export type UpdateScoreCardConfigAction = {
  type: typeof UPDATE_SCORE_CARD_CONFIG;
  payload: SCORE_CARD_CONFIG_RESPONSE;
};

export type GetFeedbackConfigAction = {
  type: typeof GET_FEEDBACK_CONFIG;
  payload: FEEDBACK_CONFIG_RESPONSE;
};

export type GetStepQuestionnaireSectionAction = {
  type: typeof GET_STEP_QUESTIONNAIRE_SECTIONS;
  payload: STEP_QUESTIONNAIRE_SECTIONS_RESPONSE[];
};

export type PostInternalFormConfigEmployeeAction = {
  type: typeof POST_INTERNAL_FORM_CONFIG_EMPLOYEE;
};

export type PostInternalFormConfigSendEmailStatusAction = {
  type: typeof POST_INTERNAL_FORM_CONFIG_SEND_EMAIL_STATUS;
};

export type PostInternalFormConfigFormSelectionAction = {
  type: typeof POST_INTERNAL_FORM_CONFIG_FORM_SELECTION;
};

export type SelectedQuestionnaireAction = {
  type: typeof SELECTED_QUESTIONNAIRE_SECTION;
  payload: JOB_STAGES;
};
export type GetJobMatchesAction = {
  type: typeof GET_JOB_MATCHES;
  payload: CandidateList;
};

export type GetTagsAction = {
  type: typeof GET_TAGS;
  payload: Tag[];
};

export type EditTagAction = {
  type: typeof EDIT_TAG;
  payload: Tag;
};

export type DeleteTagAction = {
  type: typeof DELETE_TAG;
  payload: Tag;
};

export type AddTagsToCandidateAction = {
  type: typeof ADD_TAGS_TO_CANDIDATE;
  payload: Tag[];
};

export type GetHierarchyLevelAction = {
  type: typeof GET_HIERARCHY_LEVELS;
  payload: HIERARCHY_LEVEL[];
};

export type AddTagAction = {
  type: typeof ADD_TAG;
  payload: Tag;
};

export type UpdateSelectedPendingOfferCandidateAction = {
  type: typeof UPDATE_SELECTED_PENDING_OFFER_CANDIDATE;
  payload: OFFERS_CANDIDATE_INFO;
};

export type GetCandidateJobStepsAction = {
  type: typeof GET_CANDIDATE_JOB_STEPS;
  payload: CANDIDATE_JOB_STEPS[];
};

export type GetCandidateParsingAction = {
  type: typeof CRM_CANDIDATE_PARSING;
  payload: RESUME_PARSING;
};

export type GetApplicantListAction = {
  type: typeof GET_APPLICANT_LIST;
  payload: ApplicantList;
};

export type GetApplicantListOfStageAction = {
  type: typeof GET_APPLICANT_LIST_OF_STAGE;
  stageId: number;
  payload: ApplicantList;
};

export type ResetApplicantListOfStageDataAction = {
  type: typeof RESET_APPLICANT_LIST_OF_STAGE;
};

export type UpdateApplicantListOfStageByIdAction = {
  type: typeof UPDATE_APPLICANT_LIST_OF_STAGE_BY_ID;
  payload: ApplicantList;
  stageId: number;
};

export type GetApplicantListFilterMetadataAction = {
  type: typeof GET_APPLICANT_LIST_FILTER_METADATA;
  payload: ApplicantListFilterMetadata;
};

export type GetApplicantDetailsAction = {
  type: typeof GET_APPLICANT_DETAILS;
  payload: Candidate[];
};

export type GetCandidateListAction = {
  type: typeof GET_CANDIDATE_LIST;
  payload: CandidateList;
};

export type MicrosoftLoginSuccessAction = {
  type: typeof MICROSOFT_LOGIN_SUCCESS;
  payload: MicrosoftLoginResponse;
};

export type UpdateInternalFormConfigAction = {
  type: typeof UPDATE_INTERNAL_FORM_CONFIG;
  payload: InternalFormConfig | null;
};

export type GetUntriedCountAction = {
  type: typeof GET_UNTRIED_COUNT;
  payload: number;
};

export type OptimisticMoveCandidateAction = {
  type: typeof OPTIMISTIC_MOVE_CANDIDATE_TO_STAGE;
  payload: {
    candidateId: number;
    sourceStageId: number;
    destinationStageId: number;
    candidate: PartialCandidate;
    originalIndex: number;
    collapsedDestinationStageListCount?: number;
  };
};

export type RevertOptimisticMoveCandidateAction = {
  type: typeof REVERT_OPTIMISTIC_MOVE_CANDIDATE;
  payload: {
    candidateId: number;
    sourceStageId: number;
    destinationStageId: number;
    candidate: PartialCandidate;
    originalIndex: number;
  };
};

export type OptimisticBulkMoveCandidatesAction = {
  type: typeof OPTIMISTIC_BULK_MOVE_CANDIDATES_TO_STAGE;
  payload: {
    candidates: Array<{
      candidateId: number;
      candidate: PartialCandidate;
      originalIndex: number;
    }>;
    sourceStageId: number;
    destinationStageId: number;
    collapsedDestinationStageListCount?: number;
  };
};

export type RevertOptimisticBulkMoveCandidatesAction = {
  type: typeof REVERT_OPTIMISTIC_BULK_MOVE_CANDIDATES;
  payload: {
    candidates: Array<{
      candidateId: number;
      candidate: PartialCandidate;
      originalIndex: number;
    }>;
    sourceStageId: number;
    destinationStageId: number;
  };
};

export type AddCandidateToStageAction = {
  type: typeof ADD_CANDIDATE_TO_STAGE;
  stageId: number;
  candidate: PartialCandidate;
};

export const JOB_TABS = [
  {tabId: '/crm/jobs', label: 'Actively Hiring'},
  {tabId: '/crm/jobs/draft', label: 'Draft'},
  {tabId: '/crm/jobs/closed', label: 'Closed'},
  {tabId: '/crm/jobs/archived', label: 'Archived'},
] as const;

export const JOB_CRUD_STEPS = [
  {tabId: 'details', label: 'Job Details', iconName: 'memo'},
  {tabId: 'description', label: 'Job Description', iconName: 'briefcase-blank'},
] as const;

export const JOB_INFO_TABS = [
  {tabId: 'overview', label: 'Overview', permission: true},
  {tabId: 'tasks', label: 'Tasks', permission: true},
  {
    tabId: 'matches',
    label: 'Matches',
    permission: 'VIEW_TALENT_POOL_CANDIDATES',
  },
  {
    tabId: 'applicants',
    label: 'Applicants',
    permission: 'VIEW_REQUISITION_CANDIDATES',
  },
  {tabId: 'details', label: 'Details', permission: true},
  {tabId: 'settings', label: 'Settings', permission: true},
] as const;

export const JOB_STEPS = {
  details: 'Job Details',
  description: 'Job Description',
  hiring: 'Hiring Process',
  approval: 'Approval Chain',
} as const;

export const INDUSTRY_OPTIONS = [
  'Apparel & Fashion',
  'Architecture & Planning',
  'Arts & Crafts',
  'Automotive',
  'Aviation & Aerospace',
  'Banking',
  'Biotechnology',
  'Broadcast Media',
  'Building Materials',
  'Business Supplies & Equipment',
  'Capital Markets',
  'Chemicals',
  'Civic & Social Organization',
  'Civil Engineering',
  'Commercial Real Estate',
  'Computer & Network Security',
  'Computer Games',
  'Computer Hardware',
  'Computer Networking',
  'Computer Software',
  'Construction',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Services',
  'Cosmetics',
  'Dairy',
  'Defense & Space',
  'Design',
  'E-learning',
  'Education Management',
  'Electrical & Electronic Manufacturing',
  'Entertainment',
  'Environmental Services',
  'Events Services',
  'Executive Office',
  'Facilities Services',
  'Farming',
  'Financial Services',
  'Fine Art',
  'Fishery',
  'Food & Beverages',
  'Food Production',
  'Fundraising',
  'Furniture',
  'Gambling & Casinos',
  'Glass, Ceramics & Concrete',
  'Government Administration',
  'Government Relations',
  'LinkedIn - industry',
  'Accounting',
  'Airlines/Aviation',
  'Alternative Dispute Resolution',
  'Alternative Medicine',
  'Animation',
  'Human Resources',
  'Healthcare',
  'Import & Export',
  'Individual & Family Services',
  'Industrial Automation',
  'Information Services',
  'Information Technology & Services',
  'Insurance',
  'International Affairs',
  'International Trade & Development',
  'Internet',
  'Investment Banking',
  'Investment Management',
  'Judiciary',
  'Law Enforcement',
  'Law Practice',
  'Legal Services',
  'Legislative Office',
  'Leisure, Travel & Tourism',
  'Libraries',
  'Logistics & Supply Chain',
  'Luxury Goods & Jewelry',
  'Machinery',
  'Management Consulting',
  'Maritime',
  'Market Research',
  'Marketing & Advertising',
  'Mechanical or Industrial Engineering',
  'Media Production',
  'Medical Device',
  'Medical Practice',
  'Mental Health Care',
  'Military',
  'Mining & Metals',
  'Motion Pictures & Film',
  'Museums & institutions',
  'Music',
  'Nanotechnology',
  'Newspapers',
  'Non-profit Organization Management',
  'Oil & Energy',
  'Online Media',
  'Outsourcing / Offshoring',
  'Package / Freight Delivery',
  'Packaging & Containers',
  'Paper & Forest Products',
  'Performing Arts',
  'Pharmaceuticals',
  'Philanthropy',
  'Photography Plastics',
  'Political Organization',
  'Primary/Secondary Education',
  'Printing',
  'Professional Training & Coaching',
  'Program Development',
  'Public Policy',
  'Public Relations & Communications',
  'Public Safety',
  'Publishing',
  'Railroad Manufacture',
  'Ranching',
  'Real Estate',
  'Recreational Facilities & Services',
  'Religious Institutions',
  'Renewables & Environment',
  'Research',
  'Restaurants',
  'Retail',
  'Security & Investigations',
  'Semiconductors',
  'Shipbuilding',
  'Sporting Goods',
  'Sports',
  'Staffing & Recruiting',
  'Supermarkets',
  'Telecommunications',
  'Textiles',
  'Think Tanks',
  'Tobacco',
  'Translation & Localization',
  'Transportation/Trucking/Railroad',
  'Utilities',
  'Venture Capital & Private Equity',
  'Veterinary',
  'Warehousing',
  'Wholesale',
  'Wine & Spirits',
  'Wireless',
  'Writing & Editing',
] as const;

export const FUNCTIONAL_AREA_OPTIONS = [
  'Accounts, Finance, Tax, CS & Audit',
  'Agent',
  'Analytics & Business Intelligence',
  'Architecture, Interior Design',
  'Banking',
  'Insurance',
  'Beauty, Fitness, Spa Services',
  'Content & Journalism',
  'Corporate Planning & Consulting',
  'CSR & Sustainability',
  'Engineering Design & R&D',
  'Export, Import & Merchandising',
  'Fashion, Garments & Merchandising',
  'Guards & Security Services',
  'KPO, Research',
  'Hotels & Restaurants',
  'Administration',
  'HR & IR',
  'Instructional Designer',
  'IT- Hardware, Telecom, Technical Staff & Support',
  'IT Software - Application Programming, Maintenance',
  'IT Software - Client Server',
  'IT Software - DBA, Datawarehousing',
  'IT Software - E-Commerce, Internet Technologies',
  'IT Software - Embedded,EDA,VLSI,ASIC,Chip Design',
  'IT Software - ERP, CRM',
  'IT Software - Mainframe',
  'IT Software - Middleware',
  'IT Software - Mobile',
  'IT Software - Network Administration, Security',
  'IT Software - Other',
  'IT Software - QA & Testing',
  'IT Software - System Programming',
  'IT Software -  Systems, EDP, MIS',
  'IT Software - Telecom Software',
  'ITES, BPO, KPO, Customer Service, Operations',
  'Legal',
  'Marketing, Advertising, MR, PR',
  'Operations, Process, Planning, Strategy',
  'Pharma, Biotech, Healthcare, Medical, R&D',
  'Packaging',
  'Production, Maintenance, Quality',
  'Purchase, Logistics, Supply Chain',
  'Sales, BD',
  'Secretary, Front Office, Data Entry',
  'Self Employed, Consultants',
  'Shipping',
  'Site Engineering, Project Management',
  'Teaching, Education',
  'Top Management',
  'Training & Development',
  'Ticketing, Travel, Airlines',
  'TV, Films, Production',
  'Visual Merchandising',
  'Web, Graphic Design, Visualiser',
  'Other',
] as const;

export const EMPLOYEMENT_TYPE = [
  {
    key: 'FULLTIME',
    label: 'Full-time',
  },
  {
    key: 'PARTTIME',
    label: 'Part-time',
  },
  {
    key: 'CONTRACT',
    label: 'Contract',
  },
  {
    key: 'TEMPORARY',
    label: 'Temporary',
  },
  {
    key: 'INTERN',
    label: 'Internship',
  },
] as const;

export const CURRENCY_OPTIONS = [
  {
    key: 'INR',
    label: '₹',
  },
  {
    key: 'USD',
    label: '$',
  },
  {
    key: 'EUR',
    label: '€',
  },
  {
    key: 'GPB',
    label: '£',
  },
  {
    key: 'CAD',
    label: 'c$',
  },
  {
    key: 'PHP',
    label: '₱',
  },
  {
    key: 'KSH',
    label: 'KSH',
  },
  {
    key: 'AED',
    label: 'د.إ',
  },
  {
    key: 'SGD',
    label: 's$',
  },
  {
    key: 'MYR',
    label: 'RM',
  },
  {
    key: 'MMK',
    label: 'Ks',
  },
  {
    key: 'BDT',
    label: 'Tk',
  },
  {
    key: 'NPR',
    label: 'Rs',
  },
  {
    key: 'SLR',
    label: 'Rs',
  },
  {
    key: 'SAR',
    label: 'SAR',
  },
  {
    key: 'HKD',
    label: 'HK$',
  },
] as const;

export const DETAILS_OPTIONS = [
  {
    key: 'jobDetails',
    label: 'Job Details',
    permission: true,
  },
  {
    key: 'hiringProcess',
    label: 'Hiring Process',
    permission: 'VIEW_REQUISITION_HIRING_PLAN',
  },
  {
    key: 'hiringTeam',
    label: 'Hiring Team',
    permission: 'VIEW_REQUISITION_HIRING_TEAM',
  },
  {
    key: 'approvalChain',
    label: 'Approval Chain',
    permission: 'VIEW_REQUISITION_APPROVAL',
  },
] as const;

export const JOB_STATUS_VALUES = [
  {key: 'DRAFT', label: 'Draft', semantic: 'primary'},
  {key: 'CLOSED', label: 'Closed', semantic: 'primary'},
  {key: 'OPEN', label: 'Open ', semantic: 'information'},
  {key: 'APPROVAL_PENDING', label: 'Approval Pending', semantic: 'warning'},
  {key: 'ONHOLD', label: 'On Hold', semantic: 'warning'},
  {key: 'REJECTED', label: 'Rejected', semantic: 'danger'},
  {key: 'CANCELLED', label: 'Cancelled', semantic: 'danger'},
  {key: 'TEMPLATE', label: 'Template', semantic: 'warning'},
  {key: 'FILLED', label: 'Filled', semantic: 'information'},
  {key: 'PENDING_JOINER', label: 'Pending Joiner', semantic: 'warning'},
] as const;

export const JOB_INFORMATION_INITIAL_STATE = {
  id: 0,
  createdBy: 0,
  createdOn: 0,
  updatedBy: 0,
  updatedOn: 0,
  organizationId: 0,
  title: '',
  code: '',
  organizationName: '',
  departmentId: 0,
  officeId: 0,
  gradeId: 0,
  department: '',
  descriptionInternal: '',
  descriptionExternal: '',
  crmDescriptionInternal: '',
  crmDescriptionExternal: '',
  crmSkillsAndExpertiseInternal: '',
  crmSkillsAndExpertiseExternal: '',
  location: '',
  clientDomain: '',
  functionalArea: '',
  experienceStart: '',
  experienceEnd: '',
  salaryStart: '',
  salaryEnd: '',
  salaryCurrency: '',
  chatbotConfigId: 0,
  mandatorySkills: [] as Array<never>,
  keySkills: [] as Array<never>,
  skillsAndExpertiseInternal: '',
  skillsAndExpertiseExternal: '',
  isPublished: false,
  isInternal: false,
  isReferralActive: false,
  isCritical: false,
  isActive: true,
  isDeleted: false,
  dueDate: 0,
  openPositions: 1,
  jobType: '',
  employeeType: 'SALARIED',
  jobStatus: '',
  jobDescFilekey: '',
  jobInternalDescFilekey: '',
  descriptionWordCount: 0,
  jdScore: 0,
  externalDepartment: '',
  hiringPlanId: 0,
  customFields: [] as Array<never>,
  user: {} as Record<any, any>,
  hiringTeamMembers: [] as Array<never>,
  employeeRoleId: 0,
  internalDescSameAsExternal: true,
  gradeName: '',
  jobPositions: [] as Array<never>,
  departments: [] as Array<never>,
  sorcererOperation: '',
  active: true,
  deleted: false,
  referralActive: false,
  published: false,
  internal: false,
  ijpEligible: false,
  critical: false,
  template: false,
  jobId: 0,
  new: true,
  officeLocationIds: [] as Array<never>,
  duplicateOf: 0,
  workplaceType: null,
} as const;

export const capitalizeFirstWord = (str: string): string => {
  if (!str) {
    return '';
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const KEY_LIST_REMOVE_ON_CRUD = [
  'active',
  'chatbotConfigId',
  'createdBy',
  'createdOn',
  'critical',
  'customFields',
  'deleted',
  'department',
  'departments',
  'descriptionWordCount',
  'externalDepartment',
  'gradeName',
  'hiringPlanId',
  'hiringTeamMembers',
  'id',
  'ijpEligible',
  'internal',
  'isActive',
  'isCritical',
  'isDeleted',
  'isInternal',
  'isPublished',
  'sReferralActive',
  'jdScore',
  'jobDescFilekey',
  'jobId',
  'jobInternalDescFilekey',
  'jobPositions',
  'jobStatus',
  'new',
  'organizationId',
  'published',
  'referralActive',
  'sorcererOperation',
  'updatedBy',
  'updatedOn',
  'user',
  'isReferralActive',
  'isGradeHierarchyIncomplete',
] as const;

export const VALID_ATTACHMENTS = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc', '.docx'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
  'application/vnd.ms-excel': ['.xls', '.csv'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'text/csv': ['.csv'],
  'video/mp4': ['.mp4'],
  'audio/mpeg': ['.mp3'],
} as const;

export const LOADER_TEXTS = {
  jdGen: [
    'Dream job description processing...',
    'Meticulous word selection in action',
  ],
  analyze: ['One moment while we analyze your JD'],
} as const;

export const promptsList: Array<string> = [
  'Empathetic and Supportive',

  'Friendly and Conversational',

  'Professional and Formal',

  'Gender Neutral',
];

export const ADD_PROMPT_TYPES: Array<string> = ['skills', 'responsibilities'];

export const TONE_PROMPT_TYPES: Array<string> = [
  'missingSections',
  'contentEnhancement',
];

export const PROMPT_TYPES: Array<string> = [
  ...ADD_PROMPT_TYPES,
  ...TONE_PROMPT_TYPES,
];

export const getJdScoreTextType = (
  score: number,
  t: TranslationFunction,
): string => {
  if (score > 80) {
    return t('Excellent', 'Excellent');
  } else if (score < 80 && score > 60) {
    return t('Good_could_be_better', 'Good, could be better');
  } else {
    return t('Inadequate_needs_work', 'Inadequate, needs work');
  }
};

const validationObject: ValidatedObject = {
  title: {
    errorText: 'Please enter title',
  },
  jobType: {
    errorText: 'Please select job type',
  },
  openPositions: {
    errorText: 'Please enter positions',
  },
  employeeType: {
    errorText: 'Please select employee',
  },
  officeId: {
    errorText: '',
  },
  departmentId: {
    errorText: 'Please select department',
  },
  experienceEnd: {
    errorText: '',
  },
  experienceStart: {
    errorText: '',
  },
  location: {
    errorText: 'Please add location',
  },
  salaryStart: {
    errorText: '',
  },
  salaryEnd: {
    errorText: '',
  },
};

const validateRange = (
  start: string | number | null | undefined,
  end: string | number | null | undefined,
  startKey: string,
  endKey: string,
  startError: string,
  endError: string,
  tempObject: ValidatedObject,
): void => {
  const startNum = start != null ? Number(start) : null;
  const endNum = end != null ? Number(end) : null;

  if (startNum === null && endNum === null) {
    delete tempObject[startKey];
    delete tempObject[endKey];
    return;
  }

  if (startNum !== null && endNum === null) {
    tempObject[endKey].errorText = endError;
    delete tempObject[startKey];
    return;
  }

  // Only start value is missing
  if (startNum === null && endNum !== null) {
    tempObject[startKey].errorText = startError;
    delete tempObject[endKey];
    return;
  }

  // Both values exist, check if they're valid numbers and compare them
  if (
    startNum !== null &&
    endNum !== null &&
    !isNaN(startNum) &&
    !isNaN(endNum)
  ) {
    if (startNum > endNum) {
      const baseKey = startKey.replace('Start', '');
      tempObject[
        startKey
      ].errorText = `Minimum ${baseKey} should be less than or equal to maximum ${baseKey}`;
      tempObject[
        endKey
      ].errorText = `Maximum ${baseKey} should be greater than or equal to minimum ${baseKey}`;
      return;
    }
  }

  delete tempObject[startKey];
  delete tempObject[endKey];
};

export const jobCrudValidation = (
  jobInformation: JOB_INFORMATION,
  isEmployeeRoleListAvailable: boolean,
  isGradeMandatoryInJob: boolean = false,
  strictLowestDepartmentSelection: boolean = false,
  departmentOptions: {
    readonly [parentId: number]: {
      id: number;
      name: string;
      parentId: number;
    }[];
  } = {},
  gradeOptions: {
    readonly [parentId: number]: {
      id: number;
      name: string;
      parentId: number;
    }[];
  } = {},
): ValidatedObject | null => {
  const tempObject = {...validationObject} as const;

  // Add gradeId to validation only if it's mandatory
  if (isGradeMandatoryInJob) {
    // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
    tempObject.gradeId = {
      errorText: 'Please select grade',
    };
  }

  Object.keys(tempObject).forEach((jobKey) => {
    if (jobKey === 'departmentId') {
      if (strictLowestDepartmentSelection) {
        const children = departmentOptions[jobInformation.departmentId];
        const isDepartmentIncomplete =
          Array.isArray(children) && children.length > 0;
        if (isDepartmentIncomplete) {
          // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
          tempObject.departmentId = {
            errorText:
              'Please select the lowest department level in the hierarchy',
          };
          return;
        }
      }
      if (jobInformation[jobKey as keyof JOB_INFORMATION]) {
        // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
        delete tempObject[jobKey];
      }
      return;
    }

    // Handle employee role validation
    if (jobKey === 'employeeRoleId') {
      if (isEmployeeRoleListAvailable && jobInformation[jobKey]) {
        // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
        delete tempObject[jobKey];
      }
      return;
    }

    // Handle grade validation
    if (jobKey === 'gradeId') {
      if (isGradeMandatoryInJob && jobInformation[jobKey]) {
        const gradeChildren = gradeOptions[jobInformation.gradeId];
        const isGradeIncomplete =
          Array.isArray(gradeChildren) && gradeChildren.length > 0;
        if (isGradeIncomplete) {
          // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
          tempObject.gradeId = {
            errorText: 'Please select the lowest grade level in the hierarchy',
          };
        } else {
          // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
          delete tempObject[jobKey];
        }
      }
      return;
    }

    // Handle salary range validation
    if (jobKey === 'salaryStart' || jobKey === 'salaryEnd') {
      if (jobKey === 'salaryStart') {
        validateRange(
          jobInformation.salaryStart,
          jobInformation.salaryEnd,
          'salaryStart',
          'salaryEnd',
          'Please enter minimum salary',
          'Please enter maximum salary',
          tempObject,
        );
      }
      return;
    }

    // Handle experience range validation
    if (jobKey === 'experienceStart' || jobKey === 'experienceEnd') {
      if (jobKey === 'experienceStart') {
        validateRange(
          jobInformation.experienceStart,
          jobInformation.experienceEnd,
          'experienceStart',
          'experienceEnd',
          'Please enter minimum experience',
          'Please enter maximum experience',
          tempObject,
        );
      }
      return;
    }

    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'JOB_INFORMATION'.
    if (jobInformation[jobKey]) {
      // @ts-expect-error - TS2542 - Index signature in type '{ readonly [key: string]: ValidationField; }' only permits reading.
      delete tempObject[jobKey];
    }
  });

  return Object.keys(tempObject).length > 0 ? tempObject : null;
};
export const getStepTypeFormattedName = (stepType: string): string => {
  if (stepType === 'INTERNAL_FORM') {
    return 'Internal Form';
  } else if (stepType === 'BACKGROUND_VERIFICATION') {
    return 'Background check';
  }
  return '';
};

export const PACKAGE_LISTS = [
  {
    key: 'LOCAL_ADDRESS_VERIFICATION',
    label: 'Local Address Verification',
  },
  {
    key: 'EDUCATION_VERIFICATION',
    label: 'Education Verification',
  },
  {
    key: 'EMPLOYMENT_VERIFICATION',
    label: 'Employment Verification',
  },
  {
    key: 'CRIMINAL_COURT_VERIFICATION',
    label: 'Criminal Court Verification',
  },
  {
    key: 'PAN_CARD_VERIFICATION',
    label: 'Pan Card Verification',
  },
  {
    key: 'PROFESSIONAL_REFERENCE_VERIFICATION',
    label: 'Professional Reference Verification',
  },
  {
    key: 'AADHAAR_VERIFICATION',
    label: 'Aadhaar Verification',
  },
  {
    key: 'PERMANENT_ADDRESS_POSTAL_VERIFICATION',
    label: 'Permanent Address Postal Verification',
  },
] as const;

export const BACKGROUND_VERIFICATION_PLATFORM_LIST = [
  {
    key: 'CHECKR',
    label: 'CHECKR',
  },
  {
    key: 'ONGRID',
    label: 'ONGRID',
  },
] as const;

export const getFormattedText = (text?: string): string => {
  if (!text) {
    return '';
  }

  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const converJobTypeString = (input: string): string => {
  const index = input.indexOf('TIME');
  let modifiedString;

  if (index === -1) {
    modifiedString = getFormattedText(input.toLowerCase());
  } else {
    modifiedString = input.slice(0, index) + '-' + input.slice(index);
    modifiedString = modifiedString.toLowerCase();

    // Capitalize the first letter of each word
    modifiedString = modifiedString
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join('-');
  }

  return modifiedString;
};

export const dateFormator = (
  date: number,
  t: TranslationFunction,
  makeKey: MakeKeyFunction,
): string => {
  const now = moment();
  const inputDate = moment(date);
  const diffInMinutes = now.diff(inputDate, 'minutes');
  const diffInHours = now.diff(inputDate, 'hours');
  const diffInDays = now.diff(inputDate, 'days');

  if (diffInMinutes < 1) {
    return t('just_now', 'just now');
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${t(
      makeKey(`minute${diffInMinutes > 1 ? 's' : ''}`),
      `minute${diffInMinutes > 1 ? 's' : ''}`,
    )} ${t('ago', 'ago')}`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${t(
      makeKey(`hour${diffInHours > 1 ? 's' : ''}`),
      `hour${diffInHours > 1 ? 's' : ''}`,
    )} ${t('ago', 'ago')}`;
  } else if (diffInDays === 1) {
    return t('Yesterday', 'Yesterday');
  } else if (diffInDays <= 7) {
    return `${diffInDays} ${t(
      makeKey(`day${diffInDays > 1 ? 's' : ''}`),
      `day${diffInDays > 1 ? 's' : ''}`,
    )} ${t('ago', 'ago')}`;
  } else {
    return inputDate.format('MMM Do YYYY');
  }
};

export const getExperience = (
  start: number,
  end: number,
  t: TranslationFunction,
): string => {
  if (end === 0) {
    return `0 ${t('years', 'years')}`;
  }
  return `${start} ${t('to', 'to')} ${end} ${t('years', 'years')}`;
};

export function getFormattedDate(dateInMs: number): string {
  const date = new Date(dateInMs);

  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

export const getRangeLabel = (text: string, t: TranslationFunction): string => {
  if (text === 'salaried') {
    return t('Salary_Range', 'Salary Range');
  }
  return `${getFormattedText(text)} ${t('Range', 'Range')}`;
};

export const getJoblistTab = (jobStatus: string): string => {
  switch (jobStatus) {
    case 'OPEN':
      return '/crm/jobs';
    case 'DRAFT':
    case 'APPROVAL_PENDING':
    case 'REJECTED':
      return '/crm/jobs/draft';
    case 'ONHOLD':
    case 'CANCELLED':
      return '/crm/jobs/archived';
    case 'CLOSED':
    case 'FILLED':
    case 'PENDING_JOINER':
      return '/crm/jobs/closed';
    default:
      return '/crm/jobs';
  }
};
export const getJobOptions = (jobStatus: string): Array<customMenuOption> => {
  switch (jobStatus) {
    case 'CLOSED':
      return [
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},
        {
          key: 'makeActiveCandidatesInactive',
          label: 'Make active candidates Inactive',
          permission: true,
        },
        {
          key: 'cancelThisJob',
          label: 'Cancel This Job',
          permission: 'CANCEL_JOB',
        },
      ];
    case 'ONHOLD':
      return [
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},
        {key: 'markAsOpen', label: 'Reopen this job', permission: 'OPEN_JOB'},
        {
          key: 'cancelThisJob',
          label: 'Cancel This Job',
          permission: 'CANCEL_JOB',
        },
      ];
    case 'REJECTED':
    case 'FILLED':
    case 'PENDING_JOINER':
      return [
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},
        {
          key: 'cancelThisJob',
          label: 'Cancel This Job',
          permission: 'CANCEL_JOB',
        },
      ];
    case 'DRAFT':
      return [
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},

        {key: 'saveAsTemplate', label: 'Save as Template', permission: true},
        {
          key: 'cancelThisJob',
          label: 'Cancel This Job',
          permission: 'CANCEL_JOB',
        },
        {
          key: 'downloadCandidateFeedbacks',
          label: 'Download Candidate Feedbacks',
          permission: 'DOWNLOAD_CANDIDATE_FEEDBACKS',
        },
      ];
    case 'CANCELLED':
      return [
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},
        {key: 'markAsOpen', label: 'Reopen this job', permission: 'OPEN_JOB'},
        {
          key: 'makeActiveCandidatesInactive',
          label: 'Make active candidates Inactive',
          permission: true,
        },
        // {
        //   key: 'cancelThisJob',
        //   label: 'Cancel This Job',
        //   permission: 'CANCEL_JOB',
        // },
        {
          key: 'downloadCandidateFeedbacks',
          label: 'Download Candidate Feedbacks',
          permission: 'DOWNLOAD_CANDIDATE_FEEDBACKS',
        },
      ];
    case 'OPEN':
      return [
        {key: 'markAsClosed', label: 'Mark as Closed', permission: 'CLOSE_JOB'},
        {
          key: 'putJobOnHold',
          label: 'Put Job On Hold',
          permission: 'PUT_JOB_ON_HOLD',
        },
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},
        {
          key: 'cancelThisJob',
          label: 'Cancel This Job',
          permission: 'CANCEL_JOB',
        },
        {
          key: 'downloadCandidateFeedbacks',
          label: 'Download Candidate Feedbacks',
          permission: 'DOWNLOAD_CANDIDATE_FEEDBACKS',
        },
        // ...defaultOptions,
      ];
    case 'APPROVAL_PENDING':
      return [
        {key: 'createDuplicate', label: 'Create Duplicate', permission: true},
        {
          key: 'cancelThisJob',
          label: 'Cancel This Job',
          permission: 'CANCEL_JOB',
        },
        {
          key: 'downloadCandidateFeedbacks',
          label: 'Download Candidate Feedbacks',
          permission: 'DOWNLOAD_CANDIDATE_FEEDBACKS',
        },
      ];
    default:
      return [];
  }
};

export const getFormatQuestionType = (input: string): string => {
  if (!input.includes('_')) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
  }

  return input
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const JOB_STEPS_OPTIONS: MenuOption[] = [
  {
    label: 'Interview',
    key: 'INTERVIEW',
  },
  {
    label: 'Feedback',
    key: 'FEEDBACK',
  },
  {
    label: 'Candidate Form',
    key: 'CANDIDATE_FORM',
  },
  {
    label: 'Assessment',
    key: 'ASSESSMENT',
  },
  {
    label: 'Internal Form',
    key: 'INTERNAL_FORM',
  },
  {
    label: 'Background Verification',
    key: 'BACKGROUND_VERIFICATION',
  },
];

// function isHtmlString(text) {
//   const htmlPattern = /<[^>]+>/;
//   return htmlPattern.test(text);
// }

// export const convertToHtmlBody = (text: string, style: {...}): string => {
//   if (isHtmlString(text)) {
//     return text;
//   }
//   return `<div style=\"${style}\">${text}</div>`;
// };

export const formatDate = (date: string, desiredFormat: string): string => {
  // Regular expressions for different date formats
  const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/;
  const yyyymmddRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (ddmmyyyyRegex.test(date) && desiredFormat === 'yyyy-mm-dd') {
    const [day, month, year] = date.split('-');
    return `${year}-${month}-${day}`;
  } else if (yyyymmddRegex.test(date) && desiredFormat === 'dd-mm-yyyy') {
    const [year, month, day] = date.split('-');
    return `${day}-${month}-${year}`;
  }

  return date;
};

export const CRM_PERMISSIONS = {
  CREATE_JOB: 'CREATE_JOB',
  EDIT_JOB_DESCRIPTION: 'EDIT_JOB_DESCRIPTION',
  VIEW_JOB_SALARY: 'VIEW_JOB_SALARY',
  EDIT_JOB_SALARY: 'EDIT_JOB_SALARY',
  ARCHIVE_JOB: 'ARCHIVE_JOB',
  PUBLISH_JOB: 'PUBLISH_JOB',
  ENABLE_JOB_REFERRAL: 'ENABLE_JOB_REFERRAL',
  // ASSIGN_AGENCY_JOBS: 'ASSIGN_AGENCY_JOBS',
  ASSIGN_HIRING_TEAM: 'ASSIGN_HIRING_TEAM',
  ASSIGN_HIRING_MANAGER: 'ASSIGN_HIRING_MANAGER',
  MARK_IMPORTANT_FOR_JOB: 'MARK_IMPORTANT_FOR_JOB',
  UPLOAD_CANDIDATE_TO_JOB: 'UPLOAD_CANDIDATE_TO_JOB',
  CHANGE_CANDIDATE_STATUS: 'CHANGE_CANDIDATE_STATUS',
  VIEW_OTHERS_FEEDBACK: 'VIEW_OTHERS_FEEDBACK',
  SEND_EMAIL_TO_CANDIDATE: 'SEND_EMAIL_TO_CANDIDATE',
  SEND_BULK_EMAIL_TO_CANDIDATE: 'SEND_BULK_EMAIL_TO_CANDIDATE',
  CRUD_SELF_NOTE: 'CRUD_SELF_NOTE',
  CRUD_OTHERS_NOTE: 'CRUD_OTHERS_NOTE',
  EXPORT_CANDIDATE_DETAILS: 'EXPORT_CANDIDATE_DETAILS',
  VIEW_CANDIDATE_CTC: 'VIEW_CANDIDATE_CTC',
  EDIT_CANDIDATE_DETAILS: 'EDIT_CANDIDATE_DETAILS',
  ADD_CANDIDATES_TO_JOB: 'ADD_CANDIDATES_TO_JOB',
  MOVE_REMOVE_CANDIDATE: 'MOVE_REMOVE_CANDIDATE',
  BULK_MOVE_REMOVE_CANDIDATES: 'BULK_MOVE_REMOVE_CANDIDATES',
  JOB_BOARDS: 'JOB_BOARDS',
  SHARE_RESUME: 'SHARE_RESUME',
  ADD_CANDIDATE_TAGS: 'ADD_CANDIDATE_TAGS',
  UPLOAD_CANDIDATE: 'UPLOAD_CANDIDATE',
  VIEW_REPORTS_TAB: 'VIEW_REPORTS_TAB',
  VIEW_ACTIVITY_REPORTS: 'VIEW_ACTIVITY_REPORTS',
  DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
  INTEGRATION_EMAIL: 'INTEGRATION_EMAIL',
  INTEGRATION_RESUME_MAILBOX: 'INTEGRATION_RESUME_MAILBOX',
  ASSIGN_USER_JOBS: 'ASSIGN_USER_JOBS',
  VIEW_AGENCIES: 'VIEW_AGENCIES',
  ASSIGN_JOB_AGENCIES: 'ASSIGN_JOB_AGENCIES',
  ADD_AGENCY: 'ADD_AGENCY',
  // ENABLE_AGENCY: 'ENABLE_AGENCY',
  VIEW_EMAIL_TEMPLATES: 'VIEW_EMAIL_TEMPLATES',
  EDIT_EMAIL_TEMPLATES: 'EDIT_EMAIL_TEMPLATES',
  DELETE_EMAIL_TEMPLATES: 'DELETE_EMAIL_TEMPLATES',
  ADD_EMAIL_TEMPLATES: 'ADD_EMAIL_TEMPLATES',
  VIEW_BULK_IMPORT_CANDIDATE_CSV: 'VIEW_BULK_IMPORT_CANDIDATE_CSV',
  ROLE_MASTER: 'ROLE_MASTER',
  ROLE_AGENCY: 'ROLE_AGENCY',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_JOB_ADMIN: 'ROLE_JOB_ADMIN',
  ROLE_BASIC_USER: 'ROLE_BASIC_USER',
  ADD_REFERRALS: 'ADD_REFERRALS',
  SHARE_REFERRAL_LINK: 'SHARE_REFERRAL_LINK',
  CREATE_STAGE_JOB: 'CREATE_STAGE_JOB',
  JOB_QUESTIONNAIRE: 'JOB_QUESTIONNAIRE',
  BULK_CHANGE_CANDIDATE_STATUS: 'BULK_CHANGE_CANDIDATE_STATUS',
  VIEW_NOTES: 'VIEW_NOTES',
  ADD_CANDIDATE_FEEDBACK_SELF: 'ADD_CANDIDATE_FEEDBACK_SELF',
  ADD_CANDIDATE_FEEDBACK_OTHER: 'ADD_CANDIDATE_FEEDBACK_OTHER',
  SCHEDULE_INTERVIEW: 'SCHEDULE_INTERVIEW',
  COLLECT_FEEDBACK: 'COLLECT_FEEDBACK',
  ROLLOUT_OFFER_LETTER: 'ROLLOUT_OFFER_LETTER',
  RESOLVE_UNPARSED: 'RESOLVE_UNPARSED',
  CREATE_STAGE_GLOBAL: 'CREATE_STAGE_GLOBAL',
  CREATE_NEW_NAME_STAGE: 'CREATE_NEW_NAME_STAGE',
  CREATE_NEW_NAME_INTERVIEW: 'CREATE_NEW_NAME_INTERVIEW',
  CREATE_QUESTIONNAIRE: 'CREATE_QUESTIONNAIRE',
  EDIT_AGENCY: 'EDIT_AGENCY',
  CONFIGURE_OFFER: 'CONFIGURE_OFFER',
  EDIT_CONFIGURE_OFFER: 'EDIT_CONFIGURE_OFFER',
  // CONFIGURE_OFFER_APPROVAL: 'CONFIGURE_OFFER_APPROVAL',
  CRUD_DEPARTMENTS_OFFICES: 'CRUD_DEPARTMENTS_OFFICES',
  VIEW_SELF_FEEDBACKS: 'VIEW_SELF_FEEDBACKS',
  EDIT_CANDIDATE_CTC: 'EDIT_CANDIDATE_CTC',
  VIEW_SOURCE_REPORT: 'VIEW_SOURCE_REPORT',
  VIEW_CANDIDATE_STATUS_REPORT: 'VIEW_CANDIDATE_STATUS_REPORT',
  VIEW_CANDIDATE_REJECTION_REPORT: 'VIEW_CANDIDATE_REJECTION_REPORT',
  VIEW_CANDIDATE_TIME_TO_HIRE_REPORT: 'VIEW_CANDIDATE_TIME_TO_HIRE_REPORT',
  ADD_CANDIDATE_FEEDBACK: 'ADD_CANDIDATE_FEEDBACK',
  CREATE_STEP_JOB: 'CREATE_STEP_JOB',
  CREATE_STEP_GLOBAL: 'CREATE_STEP_GLOBAL',
  VIEW_REQUISITION_CANDIDATES: 'VIEW_REQUISITION_CANDIDATES',
  VIEW_TALENT_POOL_CANDIDATES: 'VIEW_TALENT_POOL_CANDIDATES',
  VIEW_SCREEN_CANDIDATES: 'VIEW_SCREEN_CANDIDATES',
  VIEW_INTERVIEW_CANDIDATES: 'VIEW_INTERVIEW_CANDIDATES',
  VIEW_OFFER_CANDIDATES: 'VIEW_OFFER_CANDIDATES',
  VIEW_HIRE_CANDIDATES: 'VIEW_HIRE_CANDIDATES',
  VIEW_ONHOLD_CANDIDATES: 'VIEW_ONHOLD_CANDIDATES',
  VIEW_REJECTED_CANDIDATES: 'VIEW_REJECTED_CANDIDATES',
  VIEW_REQUISITION_HIRING_PLAN: 'VIEW_REQUISITION_HIRING_PLAN',
  VIEW_REQUISITION_SCORECARD: 'VIEW_REQUISITION_SCORECARD',
  VIEW_REQUISITION_HIRING_TEAM: 'VIEW_REQUISITION_HIRING_TEAM',
  VIEW_REQUISITION_EMAIL: 'VIEW_REQUISITION_EMAIL',
  VIEW_REQUISITION_SOURCING: 'VIEW_REQUISITION_SOURCING',
  VIEW_REQUISITION_APPROVAL: 'VIEW_REQUISITION_APPROVAL',
  // VIEW_REQUISITION_CANDIDATE_FEEDBACK: 'VIEW_REQUISITION_CANDIDATE_FEEDBACK',
  EDIT_REQUISITION_HIRING_PLAN: 'EDIT_REQUISITION_HIRING_PLAN',
  EDIT_REQUISITION_SCORECARD: 'EDIT_REQUISITION_SCORECARD',
  EDIT_REQUISITION_HIRING_TEAM: 'EDIT_REQUISITION_HIRING_TEAM',
  EDIT_REQUISITION_APPROVAL: 'EDIT_REQUISITION_APPROVAL',
  EDIT_REQUISITION_EMAIL: 'EDIT_REQUISITION_EMAIL',
  EDIT_REQUISITION_SOURCING: 'EDIT_REQUISITION_SOURCING',
  EDIT_REQUISITION_CANDIDATE_FEEDBACK: 'EDIT_REQUISITION_CANDIDATE_FEEDBACK',
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  VIEW_REQUISITION: 'VIEW_REQUISITION',
  VIEW_CANDIDATE: 'VIEW_CANDIDATE',
  VIEW_CAMPAIGN: 'VIEW_CAMPAIGN',
  VIEW_APPROVAL: 'VIEW_APPROVAL',
  VIEW_REPORT: 'VIEW_REPORT',
  VIEW_ANALYTICS: 'VIEW_ANALYTICS',
  VIEW_SETTING: 'VIEW_SETTING',
  VIEW_ORGANIZATION: 'VIEW_ORGANIZATION',
  EDIT_ORGANIZATION: 'EDIT_ORGANIZATION',
  VIEW_USERS: 'VIEW_USERS',
  VIEW_USER_FORM: 'VIEW_USER_FORM',
  EDIT_USER_FROM: 'EDIT_USER_FROM',
  VIEW_GROUP: 'VIEW_GROUP',
  EDIT_GROUP: 'EDIT_GROUP',
  ADD_USER: 'ADD_USER',
  ENABLE_USER: 'ENABLE_USER',
  ASSIGN_ADDITIONAL_PERMISSION: 'ASSIGN_ADDITIONAL_PERMISSION',
  IMPORT_USERS: 'IMPORT_USERS',
  VIEW_ORGANIZATION_HIRING_PLAN: 'VIEW_ORGANIZATION_HIRING_PLAN',
  VIEW_POSITION: 'VIEW_POSITION',
  VIEW_CHATBOT: 'VIEW_CHATBOT',
  VIEW_CUSTOM_FIELD: 'VIEW_CUSTOM_FIELD',
  VIEW_FEEDBACK_QUESTIONNAIRE_TEMPLATE: 'VIEW_FEEDBACK_QUESTIONNAIRE_TEMPLATE',
  VIEW_FEEDBACK_QUESTIONNAIRE_LIBRARY: 'VIEW_FEEDBACK_QUESTIONNAIRE_LIBRARY',
  VIEW_BLACKLIST: 'VIEW_BLACKLIST',
  VIEW_CAREER_PAGE: 'VIEW_CAREER_PAGE',
  EDIT_CAREER_PAGE: 'EDIT_CAREER_PAGE',
  VIEW_SCORECARD: 'VIEW_SCORECARD',
  EDIT_SCORECARD: 'EDIT_SCORECARD',
  VIEW_GLOBAL_REQUISITION_APPROVAL: 'VIEW_GLOBAL_REQUISITION_APPROVAL',
  VIEW_JOB_FORM: 'VIEW_JOB_FORM',
  VIEW_CANDIDATE_FEEDBACK: 'VIEW_CANDIDATE_FEEDBACK',
  CRUD_REASONS: 'CRUD_REASONS',
  VIEW_REFERRAL: 'VIEW_REFERRAL',
  VIEW_GLOBAL_DASHBOARD_STATS: 'VIEW_GLOBAL_DASHBOARD_STATS',
  //candidate filter permissions
  VIEW_CANDIDATE_SEARCH_FILTERS: 'VIEW_CANDIDATE_SEARCH_FILTERS',
  ADD_VIEW_EDIT_OFFER_LETTER: 'ADD_VIEW_EDIT_OFFER_LETTER',
  ENABLE_CHATBOT_SCREENING_FILTER: 'ENABLE_CHATBOT_SCREENING_FILTER',
  ENABLE_SEND_FOR_APPROVAL_OFFER_LETTER:
    'ENABLE_SEND_FOR_APPROVAL_OFFER_LETTER',
  VIEW_DASHBOARD_GRAPH: 'VIEW_DASHBOARD_GRAPH',
  VIEW_DRIVE: 'VIEW_DRIVE',
  CREATE_DRIVE: 'CREATE_DRIVE',
  EDIT_DRIVE: 'EDIT_DRIVE',
  VIEW_USER_ACTIVITY_REPORT: 'VIEW_USER_ACTIVITY_REPORT',
  VIEW_JOB_ANALYSIS_REPORT: 'VIEW_JOB_ANALYSIS_REPORT',
  VIEW_SOURCE_ANALYTICS_REPORT: 'VIEW_SOURCE_ANALYTICS_REPORT',
  VIEW_CANDIDATE_ANALYTICS_REPORT: 'VIEW_CANDIDATE_ANALYTICS_REPORT',
  VIEW_HIRING_PATTERN_REPORT: 'VIEW_HIRING_PATTERN_REPORT',
  VIEW_OLD_REPORT: 'VIEW_OLD_REPORT',
  VIEW_CUSTOM_REPORT: 'VIEW_CUSTOM_REPORT',
  EDIT_MASKING_CONFIG: 'EDIT_MASKING_CONFIG',
  VIEW_MASKING_CONFIG: 'VIEW_MASKING_CONFIG',
  EDIT_OFFER_APPROVAL: 'EDIT_OFFER_APPROVAL',
  VIEW_USER_INFORMATION: 'VIEW_USER_INFORMATION',
  EDIT_USER_INFORMATION: 'EDIT_USER_INFORMATION',
  EDIT_USER_GROUPS: 'EDIT_USER_GROUPS',
  EDIT_USER_ROLE: 'EDIT_USER_ROLE',
  EDIT_USER_SUBSCRIPTION: 'EDIT_USER_SUBSCRIPTION',
  EDIT_EMAIL_AUTOMATION: 'EDIT_EMAIL_AUTOMATION',
  VIEW_EMAIL_AUTOMATION: 'VIEW_EMAIL_AUTOMATION',
  EDIT_JOB_TEMPLATE: 'EDIT_JOB_TEMPLATE',
  VIEW_JOB_TEMPLATE: 'VIEW_JOB_TEMPLATE',
  VIEW_REQUISITION_LIST: 'VIEW_REQUISITION_LIST',
  JOB_ASSIGNED_TO_ME: 'JOB_ASSIGNED_TO_ME',
  EDIT_DEFAULT_PERMISSION_SUBSCRIPTION: 'EDIT_DEFAULT_PERMISSION_SUBSCRIPTION',
  VIEW_DEFAULT_PERMISSION_SUBSCRIPTION: 'VIEW_DEFAULT_PERMISSION_SUBSCRIPTION',
  //new permissions
  EDIT_REFERRAL: 'EDIT_REFERRAL',
  EDIT_REFERRAL_FORM: 'EDIT_REFERRAL_FORM',
  EDIT_BULK_IMPORT_POSITION: 'EDIT_BULK_IMPORT_POSITION',
  EDIT_JOB_BOARD: 'EDIT_JOB_BOARD',
  EDIT_TIMEZONE: 'EDIT_TIMEZONE',
  EDIT_SIGNATURE: 'EDIT_SIGNATURE',
  // EDIT_STAGE_GLOBAL: 'EDIT_STAGE_GLOBAL',
  // EDIT_NEW_NAME_STAGE: 'EDIT_NEW_NAME_STAGE',
  EDIT_BULK_IMPORT_CANDIDATE_CSV: 'EDIT_BULK_IMPORT_CANDIDATE_CSV',
  CREATE_REASON: 'CREATE_REASON',
  EDIT_REASON: 'EDIT_REASON',
  VIEW_REASONS: 'VIEW_REASONS',
  EDIT_AGENCY_APPLICATION_FORM: 'EDIT_AGENCY_APPLICATION_FIELD',
  ENABLE_DISABLE_AGENCY: 'ENABLE_DISABLE_AGENCY',
  EDIT_QUESTIONNAIRE: 'EDIT_QUESTIONNAIRE',
  VIEW_OFFICES_DEPARTMENTS: 'VIEW_OFFICES_DEPARTMENTS',
  ADD_OFFICE_DEPARTMENT: 'ADD_OFFICE_DEPARTMENT',
  EDIT_OFFICE_DEPARTMENT: 'EDIT_OFFICE_DEPARTMENT',
  CREATE_OFFER_APPROVAL: 'CREATE_OFFER_APPROVAL',
  VIEW_GLOBAL_OFFER_APPROVAL: 'VIEW_GLOBAL_OFFER_APPROVAL',
  ADD_BLACKLIST: 'ADD_BLACKLIST',
  EDIT_BLACKLIST: 'EDIT_BLACKLIST',
  EDIT_JOB_FORM: 'EDIT_JOB_FORM',
  CREATE_CHATBOT: 'CREATE_CHATBOT',
  EDIT_CHATBOT: 'EDIT_CHATBOT',
  EDIT_CUSTOM_FIELD: 'EDIT_CUSTOM_FIELD',
  ADD_CUSTOM_FIELD: 'ADD_CUSTOM_FIELD',
  EDIT_ORGANIZATION_HIRING_PLAN: 'EDIT_ORGANIZATION_HIRING_PLAN',
  VIEW_REQUISITION_EMAIL_CONFIGURATION: 'VIEW_REQUISITION_EMAIL_CONFIGURATION',
  CREATE_REQUISITION_STAGE: 'CREATE_REQUISITION_STAGE',
  CREATE_REQUISITION_STEP: 'CREATE_REQUISITION_STEP',
  EDIT_NOTIFICATION: 'EDIT_NOTIFICATION',
  VIEW_CANDIDATE_EXPERIENCE_SURVEY: 'VIEW_CANDIDATE_EXPERIENCE_SURVEY',
  EDIT_CANDIDATE_EXPERIENCE_SURVEY: 'EDIT_CANDIDATE_EXPERIENCE_SURVEY',
  CREATE_REQUISITION_APPROVAL: 'CREATE_REQUISITION_APPROVAL',
  VIEW_GLOBAL_HIRING_PLAN: 'VIEW_GLOBAL_HIRING_PLAN',
  EDIT_GLOBAL_HIRING_PLAN: 'EDIT_GLOBAL_HIRING_PLAN',
  VIEW_INTEGRATION: 'VIEW_INTEGRATION',
  IMPORT_CANDIDATE_CSV: 'IMPORT_CANDIDATE_CSV',
  VIEW_REQUISITION_CANDIDATE_EXPERIENCE_SURVEY:
    'VIEW_REQUISITION_CANDIDATE_EXPERIENCE_SURVEY',
  EDIT_REQUISITION_CANDIDATE_EXPERIENCE_SURVEY:
    'EDIT_REQUISITION_CANDIDATE_EXPERIENCE_SURVEY',
  EDIT_PROFILE: 'EDIT_PROFILE',
  INVITE_CANDIDATE_CHATBOT: 'INVITE_CANDIDATE_CHATBOT',
  CRUD_ATTACHMENT: 'CRUD_ATTACHMENT',
  EDIT_INTERNAL_JOB_POSTING: 'EDIT_INTERNAL_JOB_POSTING',
  EDIT_CHATBOT_FLOW: 'EDIT_CHATBOT_FLOW',
  VIEW_INTERNAL_JOB_POSTING: 'VIEW_INTERNAL_JOB_POSTING',
  CREATE_CAMPAIGN: 'CREATE_CAMPAIGN',
  EDIT_CAMPAIGN_WORKFLOW: 'EDIT_CAMPAIGN_WORKFLOW',
  EDIT_CAMPAIGN_SETUP: 'EDIT_CAMPAIGN_SETUP',
  START_STOP_CAMPAIGN: 'START_STOP_CAMPAIGN',
  VIEW_POSITION_MAPPING: 'VIEW_POSITION_MAPPING',
  EDIT_POSITION_MAPPING: 'EDIT_POSITION_MAPPING',
  ADD_POSITION: 'ADD_POSITION',
  DELETE_POSITION: 'DELETE_POSITION',
  BULK_IMPORT_DATA: 'BULK_IMPORT_DATA',
  JOB_NOTE_EDIT: 'JOB_NOTE_EDIT',
  VIEW_IJP_POLICY: 'VIEW_IJP_POLICY',
  EDIT_IJP_POLICY: 'EDIT_IJP_POLICY',
  ADD_NOTE_TYPE: 'ADD_NOTE_TYPE',
  EDIT_NOTE_TYPE: 'EDIT_NOTE_TYPE',
  DELETE_NOTE_TYPE: 'DELETE_NOTE_TYPE',
  CREATE_PRIVATE_NOTE: 'CREATE_PRIVATE_NOTE',
  ADD_CANDIDATE_ROUND: 'ADD_CANDIDATE_ROUND',
  MOVE_TO_NEXT_STAGE_IN_REFERRAL: 'MOVE_TO_NEXT_STAGE_IN_REFERRAL',
  VIEW_OVERALL_RECOMMENDATION: 'VIEW_OVERALL_RECOMMENDATION',
  VIEW_RATING_SYSTEM: 'VIEW_RATING_SYSTEM',
  EDIT_RATING_SYSTEM: 'EDIT_RATING_SYSTEM',
  ASSESSMENT_INVITE: 'ASSESSMENT_INVITE',
  CREATE_PUBLIC_TAGS: 'CREATE_PUBLIC_TAGS',
  EDIT_PUBLIC_TAGS: 'EDIT_PUBLIC_TAGS',
  DELETE_PUBLIC_TAGS: 'DELETE_PUBLIC_TAGS',
  EDIT_INTERNAL_FORM: 'EDIT_INTERNAL_FORM',
  VIEW_INTERNAL_FORM: 'VIEW_INTERNAL_FORM',
  EDIT_CANDIDATE_FORM: 'EDIT_CANDIDATE_FORM',
  VIEW_CANDIDATE_FORM: 'VIEW_CANDIDATE_FORM',
  VIEW_FORM_TAB: 'VIEW_FORM_TAB',
  EDIT_CANDIDATE_FEEDBACK_OTHER: 'EDIT_CANDIDATE_FEEDBACK_OTHER',
  DOWNLOAD_CANDIDATE_FEEDBACKS: 'DOWNLOAD_CANDIDATE_FEEDBACKS',
  CANCEL_JOB: 'CANCEL_JOB',
  PUT_JOB_ON_HOLD: 'PUT_JOB_ON_HOLD',
  CLOSE_JOB: 'CLOSE_JOB',
  EDIT_DUE_DATE: 'EDIT_DUE_DATE',
  VIEW_AOP: 'VIEW_AOP',
  EDIT_AOP: 'EDIT_AOP',
  DELETE_AOP_POSITION: 'DELETE_AOP_POSITION',
  ADD_TEAM: 'ADD_TEAM',
  EDIT_TEAM: 'EDIT_TEAM',
  VIEW_TEAM: 'VIEW_TEAM',
  OPEN_JOB: 'OPEN_JOB',
  VIEW_GLOBAL_CANDIDATE_DASHBOARD_STATS:
    'VIEW_GLOBAL_CANDIDATE_DASHBOARD_STATS',
  CREATE_REQUISITION_FROM_EXISTING_JOB: 'CREATE_REQUISITION_FROM_EXISTING_JOB',
  CREATE_REQUISITION_FROM_SCRATCH: 'CREATE_REQUISITION_FROM_SCRATCH',
  GLOBAL_STEP_CONFIGURE: 'GLOBAL_STEP_CONFIGURE',
  REQUISITION_STEP_CONFIGURE: 'REQUISITION_STEP_CONFIGURE',
  MILESTONE_ANALYTICS_REPORT: 'MILESTONE_ANALYTICS_REPORT',
  JOB_STATUS_ANALYTICS_REPORT: 'JOB_STATUS_ANALYTICS_REPORT',
  JOB_AGE_ANALYTICS_REPORT: 'JOB_AGE_ANALYTICS_REPORT',
  USER_ACTIVITY_ANALYTICS_REPORT: 'USER_ACTIVITY_ANALYTICS_REPORT',
  SOURCE_ANALYTICS_REPORT: 'SOURCE_ANALYTICS_REPORT',
  ASSIGN_POSITION_ID_TO_CANDIDATE: 'ASSIGN_POSITION_ID_TO_CANDIDATE',
  EDIT_CANDIDATE_CUSTOM_FIELD: 'EDIT_CANDIDATE_CUSTOM_FIELD',
  DOWNLOAD_CANDIDATE_EXPERIENCE_SURVEY: 'DOWNLOAD_CANDIDATE_EXPERIENCE_SURVEY',
  HIRING_MANAGER_SURVEY: 'HIRING_MANAGER_SURVEY',
  EDIT_OVERALL_RECOMMENDATION: 'EDIT_OVERALL_RECOMMENDATION',
  EDIT_JOB_SYSTEM_FIELDS: 'EDIT_JOB_SYSTEM_FIELDS',
  VIEW_EMPLOYEE_REFERRAL_PAGE: 'VIEW_EMPLOYEE_REFERRAL_PAGE',
  VIEW_EMPLOYEE_JOB_PAGE: 'VIEW_EMPLOYEE_JOB_PAGE',
  VIEW_IJP_REQUISITIONS: 'VIEW_IJP_REQUISITIONS',
  VIEW_SOURCE_TRAIL: 'VIEW_SOURCE_TRAIL',
  ENABLE_SHARED_CALENDAR: 'ENABLE_SHARED_CALENDAR',
  VIEW_CANDIDATE_ACTIVITY_LOG: 'VIEW_CANDIDATE_ACTIVITY_LOG',
  VIEW_CANDIDATE_ATTACHMENTS: 'VIEW_CANDIDATE_ATTACHMENTS',
  VIEW_CANDIDATE_FEEDBACK_TAB: 'VIEW_CANDIDATE_FEEDBACK_TAB',
  VIEW_CANDIDATE_SCORECARD_TAB: 'VIEW_CANDIDATE_SCORECARD_TAB',
  VIEW_CANDIDATE_STAGE_TAB: 'VIEW_CANDIDATE_STAGE_TAB',
  VIEW_CANDIDATE_EXPERIENCE_TAB: 'VIEW_CANDIDATE_EXPERIENCE_TAB',
  REVOKE_OFFER_LETTER: 'REVOKE_OFFER_LETTER',
  CHATBOT_INTERVIEW_SCHEDULE: 'CHATBOT_INTERVIEW_SCHEDULE',
  VIEW_CANDIDATE_CUSTOM_FIELD: 'VIEW_CANDIDATE_CUSTOM_FIELD',
  EDIT_MILESTONES: 'EDIT_MILESTONES',
  REFER_CANDIDATE_WITHOUT_JOB: 'REFER_CANDIDATE_WITHOUT_JOB',
  ASSIGN_AGENCY_CAPPING: 'ASSIGN_AGENCY_CAPPING',
  VIEW_PRIVATE_CANDIDATE: 'VIEW_PRIVATE_CANDIDATE',
  ACCESS_CANDIDATE_PIPELINE: 'ACCESS_CANDIDATE_PIPELINE',
  ACCESS_AGENCY_REPORT: 'ACCESS_AGENCY_REPORT',
  ACCESS_CANDIDATE_WISE: 'ACCESS_CANDIDATE_WISE',
  ACCESS_RECRUITER_QUALITY: 'ACCESS_RECRUITER_QUALITY',
  ACCESS_CANDIDATE_EXPERIENCE_SURVEY: 'ACCESS_CANDIDATE_EXPERIENCE_SURVEY',
  ACCESS_TIME_TO_HIRE_BY_JOB: 'ACCESS_TIME_TO_HIRE_BY_JOB',
  ACCESS_INTERVIEW_REPORT: 'ACCESS_INTERVIEW_REPORT',
  ACCESS_OFFER_REPORT: 'ACCESS_OFFER_REPORT',
  VIEW_FORMS_IN_SETTING: 'VIEW_FORMS_IN_SETTING',
  SEND_OFFER_LETTER_VIA_SKILLATE: 'SEND_OFFER_LETTER_VIA_SKILLATE',
  DOWNLOAD_OFFER_LETTER_WORD_DOC: 'DOWNLOAD_OFFER_LETTER_WORD_DOC',
  CONFIG_CUSTOM_FIELDS_VIEW: 'CONFIG_CUSTOM_FIELDS_VIEW',
  CONFIG_SOURCING_FORM_FIELDS: 'CONFIG_SOURCING_FORM_FIELDS',
  VIEW_APPLN_FIELDS_CAND: 'VIEW_APPLN_FIELDS_CAND',
  VIEW_INTERVIEW_SETTINGS: 'VIEW_INTERVIEW_SETTINGS',
  EDIT_INTERVIEW_SETTINGS: 'EDIT_INTERVIEW_SETTINGS',
  VIEW_SIGMA_REPORT: 'VIEW_SIGMA_REPORT',
  VIEW_IJP_JOB_FILTER: 'VIEW_IJP_JOB_FILTER',
  SHOW_RECOMMENDED_JOBS_REFERRAL: 'SHOW_RECOMMENDED_JOBS_REFERRAL',
  SHOW_RECOMMENDED_JOBS_CANDIDATE_DETAIL:
    'SHOW_RECOMMENDED_JOBS_CANDIDATE_DETAIL',
  SEND_MESSAGE_TO_CANDIDATE: 'SEND_MESSAGE_TO_CANDIDATE',
  VIEW_ONBOARDING_TAB: 'VIEW_ONBOARDING_TAB',
  VIEW_ONBOARDING_SETTINGS: 'VIEW_ONBOARDING_SETTINGS',
  EDIT_ONBOARDING_SETTINGS: 'EDIT_ONBOARDING_SETTINGS',
  ACCESS_ONBOARDING_STATUS_REPORT: 'ACCESS_ONBOARDING_STATUS_REPORT',
  ENABLE_LOOK_A_LIKE: 'ENABLE_LOOK_A_LIKE',

  DOWNLOAD_OFFER_LETTER_PDF: 'DOWNLOAD_OFFER_LETTER_PDF',
  VIEW_APPLICATION_QUESTIONS: 'VIEW_APPLICATION_QUESTIONS',
  EDIT_APPLICATION_QUESTIONS: 'EDIT_APPLICATION_QUESTIONS',
  VIEW_APPLICATION_QUESTIONS_CAREERS_PAGE:
    'VIEW_APPLICATION_QUESTIONS_CAREERS_PAGE',
  VIEW_APPLICATION_QUESTIONS_REFERRALS: 'VIEW_APPLICATION_QUESTIONS_REFERRALS',
  VIEW_APPLICATION_QUESTIONS_AGENCY: 'VIEW_APPLICATION_QUESTIONS_AGENCY',
  VIEW_APPLICATION_QUESTIONS_IJP: 'VIEW_APPLICATION_QUESTIONS_IJP',
  SHARE_SOCIAL_MEDIA_LINK: 'SHARE_SOCIAL_MEDIA_LINK',
  VIEW_CANDIDATE_DEFAULT_FIELD: 'VIEW_CANDIDATE_DEFAULT_FIELD',
  ADD_OR_CREATE_AOP: 'ADD_OR_CREATE_AOP',
  ADD_EDIT_DELETE_AOP_EMPLOYEE_ROLE: 'ADD_EDIT_DELETE_AOP_EMPLOYEE_ROLE',
  ENABLE_JD_ANALYSER: 'ENABLE_JD_ANALYSER',
  VIEW_RESUME_MAILBOX: 'VIEW_RESUME_MAILBOX',
} as const;

export const havePermissionForAppShell = (
  permission: string | string[],
): boolean => {
  if (
    permission === CRM_PERMISSIONS.VIEW_ONBOARDING_TAB &&
    !isOnboardingEnabled()
  ) {
    return false;
  }

  const state = window.senseStore.reduxStore.getState();
  const {user_info} = state.crm;

  if (!permission) {
    return true;
  }
  if (!user_info) {
    return false;
  }
  const {roleTitle} = user_info.user ?? {};
  const {permissions = []} = user_info.user ?? {};
  if (roleTitle === 'MASTER') {
    return true;
  }

  if (typeof permission === 'string') {
    return permissions.indexOf(permission) >= 0;
  }
  if (Array.isArray(permission)) {
    let isAuthorized = true;
    permission.forEach((v) => {
      isAuthorized = isAuthorized && permissions.indexOf(v) >= 0;
    });
    return isAuthorized;
  }
  return false;
};

export const isOnboardingEnabled = (): boolean => {
  const state = window.senseStore.reduxStore.getState();
  const {accounts, crm} = state;
  const {user_info} = crm;
  if (!user_info || !user_info.organization) {
    return false;
  }
  return user_info.organization.onboardingEnabled;
};

export const useAopEnabled = (): boolean => {
  const state = window.senseStore.reduxStore.getState();
  const {accounts, crm} = state;
  const {user_info} = crm;
  if (!user_info || !user_info.organization) {
    return false;
  }
  return user_info.organization.aopEnabled;
};

export const useWorkplaceTypeEnabled = (): boolean => {
  const state = window.senseStore.reduxStore.getState();
  const {accounts, crm} = state;
  const {user_info} = crm;
  if (!user_info || !user_info.organization) {
    return false;
  }
  return user_info.organization.workplaceTypeEnabled;
};

export const currentLangauge =
  typeof navigator !== 'undefined' && navigator.language
    ? navigator.language.split(/[-_]/)[0]
    : 'en';

export const TIMEZONE_MAP = {
  'Asia/Kabul': 'UTC +04:30',
  'Europe/Mariehamn': 'UTC +03:00',
  'Europe/Tirane': 'UTC +02:00',
  'Africa/Algiers': 'UTC +01:00',
  'Pacific/Pago_Pago': 'UTC -11:00',
  'Europe/Andorra': 'UTC +02:00',
  'Africa/Luanda': 'UTC +01:00',
  'America/Anguilla': 'UTC -04:00',
  'America/Antigua': 'UTC -04:00',
  'America/Argentina/Buenos_Aires': 'UTC -03:00',
  'America/Argentina/Catamarca': 'UTC -03:00',
  'America/Argentina/Cordoba': 'UTC -03:00',
  'America/Argentina/Jujuy': 'UTC -03:00',
  'America/Argentina/La_Rioja': 'UTC -03:00',
  'America/Argentina/Mendoza': 'UTC -03:00',
  'America/Argentina/Rio_Gallegos': 'UTC -03:00',
  'America/Argentina/Salta': 'UTC -03:00',
  'America/Argentina/San_Juan': 'UTC -03:00',
  'America/Argentina/San_Luis': 'UTC -03:00',
  'America/Argentina/Tucuman': 'UTC -03:00',
  'America/Argentina/Ushuaia': 'UTC -03:00',
  'Asia/Yerevan': 'UTC +04:00',
  'America/Aruba': 'UTC -04:00',
  'Australia/Adelaide': 'UTC +09:30',
  'Australia/Brisbane': 'UTC +10:00',
  'Australia/Broken_Hill': 'UTC +09:30',
  'Australia/Currie': 'UTC +10:00',
  'Australia/Darwin': 'UTC +09:30',
  'Australia/Eucla': 'UTC +08:45',
  'Australia/Hobart': 'UTC +10:00',
  'Australia/Lindeman': 'UTC +10:00',
  'Australia/Lord_Howe': 'UTC +10:30',
  'Australia/Melbourne': 'UTC +10:00',
  'Australia/Perth': 'UTC +08:00',
  'Australia/Sydney': 'UTC +10:00',
  'Europe/Vienna': 'UTC +02:00',
  'Asia/Baku': 'UTC +04:00',
  'America/Nassau': 'UTC -04:00',
  'Asia/Bahrain': 'UTC +03:00',
  'Asia/Dhaka': 'UTC +06:00',
  'America/Barbados': 'UTC -04:00',
  'Europe/Minsk': 'UTC +03:00',
  'Europe/Brussels': 'UTC +02:00',
  'America/Belize': 'UTC -06:00',
  'Africa/Porto-Novo': 'UTC +01:00',
  'Atlantic/Bermuda': 'UTC -03:00',
  'Asia/Thimphu': 'UTC +06:00',
  'America/La_Paz': 'UTC -04:00',
  'America/Kralendijk': 'UTC -04:00',
  'Europe/Sarajevo': 'UTC +02:00',
  'Africa/Gaborone': 'UTC +02:00',
  'America/Araguaina': 'UTC -03:00',
  'America/Bahia': 'UTC -03:00',
  'America/Belem': 'UTC -03:00',
  'America/Boa_Vista': 'UTC -04:00',
  'America/Campo_Grande': 'UTC -04:00',
  'America/Cuiaba': 'UTC -04:00',
  'America/Eirunepe': 'UTC -05:00',
  'America/Fortaleza': 'UTC -03:00',
  'America/Maceio': 'UTC -03:00',
  'America/Manaus': 'UTC -04:00',
  'America/Noronha': 'UTC -02:00',
  'America/Porto_Velho': 'UTC -04:00',
  'America/Recife': 'UTC -03:00',
  'America/Rio_Branco': 'UTC -05:00',
  'America/Santarem': 'UTC -03:00',
  'America/Sao_Paulo': 'UTC -03:00',
  'Indian/Chagos': 'UTC +06:00',
  'America/Tortola': 'UTC -04:00',
  'Asia/Brunei': 'UTC +08:00',
  'Europe/Sofia': 'UTC +03:00',
  'Africa/Ouagadougou': 'UTC',
  'Africa/Bujumbura': 'UTC +02:00',
  'Asia/Phnom_Penh': 'UTC +07:00',
  'Africa/Douala': 'UTC +01:00',
  'America/Atikokan': 'UTC -05:00',
  'America/Blanc-Sablon': 'UTC -04:00',
  'America/Cambridge_Bay': 'UTC -06:00',
  'America/Creston': 'UTC -07:00',
  'America/Dawson': 'UTC -07:00',
  'America/Dawson_Creek': 'UTC -07:00',
  'America/Edmonton': 'UTC -06:00',
  'America/Fort_Nelson': 'UTC -07:00',
  'America/Glace_Bay': 'UTC -03:00',
  'America/Goose_Bay': 'UTC -03:00',
  'America/Halifax': 'UTC -03:00',
  'America/Inuvik': 'UTC -06:00',
  'America/Iqaluit': 'UTC -04:00',
  'America/Moncton': 'UTC -03:00',
  'America/Nipigon': 'UTC -04:00',
  'America/Pangnirtung': 'UTC -04:00',
  'America/Rainy_River': 'UTC -05:00',
  'America/Rankin_Inlet': 'UTC -05:00',
  'America/Regina': 'UTC -06:00',
  'America/Resolute': 'UTC -05:00',
  'America/St_Johns': 'UTC -02:30',
  'America/Swift_Current': 'UTC -06:00',
  'America/Thunder_Bay': 'UTC -04:00',
  'America/Toronto': 'UTC -04:00',
  'America/Vancouver': 'UTC -07:00',
  'America/Whitehorse': 'UTC -07:00',
  'America/Winnipeg': 'UTC -05:00',
  'America/Yellowknife': 'UTC -06:00',
  'Atlantic/Cape_Verde': 'UTC -01:00',
  'America/Cayman': 'UTC -05:00',
  'Africa/Bangui': 'UTC +01:00',
  'Africa/Ndjamena': 'UTC +01:00',
  'America/Punta_Arenas': 'UTC -03:00',
  'America/Santiago': 'UTC -04:00',
  'Pacific/Easter': 'UTC -06:00',
  'Asia/Shanghai': 'UTC +08:00',
  'Asia/Urumqi': 'UTC +06:00',
  'Indian/Christmas': 'UTC +07:00',
  'Indian/Cocos': 'UTC +06:30',
  'America/Bogota': 'UTC -05:00',
  'Indian/Comoro': 'UTC +03:00',
  'Pacific/Rarotonga': 'UTC -10:00',
  'America/Costa_Rica': 'UTC -06:00',
  'Europe/Zagreb': 'UTC +02:00',
  'America/Havana': 'UTC -04:00',
  'America/Curacao': 'UTC -04:00',
  'Asia/Famagusta': 'UTC +03:00',
  'Asia/Nicosia': 'UTC +03:00',
  'Europe/Prague': 'UTC +02:00',
  'Africa/Kinshasa': 'UTC +01:00',
  'Africa/Lubumbashi': 'UTC +02:00',
  'Europe/Copenhagen': 'UTC +02:00',
  'Africa/Djibouti': 'UTC +03:00',
  'America/Dominica': 'UTC -04:00',
  'America/Santo_Domingo': 'UTC -04:00',
  'Asia/Dili': 'UTC +09:00',
  'America/Guayaquil': 'UTC -05:00',
  'Pacific/Galapagos': 'UTC -06:00',
  'Africa/Cairo': 'UTC +02:00',
  'America/El_Salvador': 'UTC -06:00',
  'Africa/Malabo': 'UTC +01:00',
  'Africa/Asmara': 'UTC +03:00',
  'Europe/Tallinn': 'UTC +03:00',
  'Africa/Addis_Ababa': 'UTC +03:00',
  'Atlantic/Stanley': 'UTC -03:00',
  'Atlantic/Faroe': 'UTC +01:00',
  'Pacific/Fiji': 'UTC +12:00',
  'Europe/Helsinki': 'UTC +03:00',
  'Europe/Paris': 'UTC +02:00',
  'America/Cayenne': 'UTC -03:00',
  'Pacific/Gambier': 'UTC -09:00',
  'Pacific/Marquesas': 'UTC -09:30',
  'Pacific/Tahiti': 'UTC -10:00',
  'Indian/Kerguelen': 'UTC +05:00',
  'Africa/Libreville': 'UTC +01:00',
  'Africa/Banjul': 'UTC',
  'Asia/Tbilisi': 'UTC +04:00',
  'Europe/Berlin': 'UTC +02:00',
  'Europe/Busingen': 'UTC +02:00',
  'Africa/Accra': 'UTC',
  'Europe/Gibraltar': 'UTC +02:00',
  'Europe/Athens': 'UTC +03:00',
  'America/Danmarkshavn': 'UTC',
  'America/Godthab': 'UTC -02:00',
  'America/Scoresbysund': 'UTC',
  'America/Thule': 'UTC -03:00',
  'America/Grenada': 'UTC -04:00',
  'America/Guadeloupe': 'UTC -04:00',
  'Pacific/Guam': 'UTC +10:00',
  'America/Guatemala': 'UTC -06:00',
  'Europe/Guernsey': 'UTC +01:00',
  'Africa/Conakry': 'UTC',
  'Africa/Bissau': 'UTC',
  'America/Guyana': 'UTC -04:00',
  'America/Port-au-Prince': 'UTC -04:00',
  'America/Tegucigalpa': 'UTC -06:00',
  'Asia/Hong_Kong': 'UTC +08:00',
  'Europe/Budapest': 'UTC +02:00',
  'Atlantic/Reykjavik': 'UTC',
  'Asia/Kolkata': 'UTC +05:30',
  'Asia/Calcutta': 'UTC +05:30',
  'Asia/Jakarta': 'UTC +07:00',
  'Asia/Jayapura': 'UTC +09:00',
  'Asia/Makassar': 'UTC +08:00',
  'Asia/Pontianak': 'UTC +07:00',
  'Asia/Tehran': 'UTC +04:30',
  'Asia/Baghdad': 'UTC +03:00',
  'Europe/Dublin': 'UTC +01:00',
  'Europe/Isle_of_Man': 'UTC +01:00',
  'Asia/Jerusalem': 'UTC +03:00',
  'Europe/Rome': 'UTC +02:00',
  'Africa/Abidjan': 'UTC',
  'America/Jamaica': 'UTC -05:00',
  'Asia/Tokyo': 'UTC +09:00',
  'Europe/Jersey': 'UTC +01:00',
  'Asia/Amman': 'UTC +03:00',
  'Asia/Almaty': 'UTC +06:00',
  'Asia/Aqtau': 'UTC +05:00',
  'Asia/Aqtobe': 'UTC +05:00',
  'Asia/Atyrau': 'UTC +05:00',
  'Asia/Oral': 'UTC +05:00',
  'Asia/Qyzylorda': 'UTC +06:00',
  'Africa/Nairobi': 'UTC +03:00',
  'Pacific/Enderbury': 'UTC +13:00',
  'Pacific/Kiritimati': 'UTC +14:00',
  'Pacific/Tarawa': 'UTC +12:00',
  'Asia/Kuwait': 'UTC +03:00',
  'Asia/Bishkek': 'UTC +06:00',
  'Asia/Vientiane': 'UTC +07:00',
  'Europe/Riga': 'UTC +03:00',
  'Asia/Beirut': 'UTC +03:00',
  'Africa/Maseru': 'UTC +02:00',
  'Africa/Monrovia': 'UTC',
  'Africa/Tripoli': 'UTC +02:00',
  'Europe/Vaduz': 'UTC +02:00',
  'Europe/Vilnius': 'UTC +03:00',
  'Europe/Luxembourg': 'UTC +02:00',
  'Asia/Macau': 'UTC +08:00',
  'Europe/Skopje': 'UTC +02:00',
  'Indian/Antananarivo': 'UTC +03:00',
  'Africa/Blantyre': 'UTC +02:00',
  'Asia/Kuala_Lumpur': 'UTC +08:00',
  'Asia/Kuching': 'UTC +08:00',
  'Indian/Maldives': 'UTC +05:00',
  'Africa/Bamako': 'UTC',
  'Europe/Malta': 'UTC +02:00',
  'Pacific/Kwajalein': 'UTC +12:00',
  'Pacific/Majuro': 'UTC +12:00',
  'America/Martinique': 'UTC -04:00',
  'Africa/Nouakchott': 'UTC',
  'Indian/Mauritius': 'UTC +04:00',
  'Indian/Mayotte': 'UTC +03:00',
  'America/Bahia_Banderas': 'UTC -05:00',
  'America/Cancun': 'UTC -05:00',
  'America/Chihuahua': 'UTC -06:00',
  'America/Hermosillo': 'UTC -07:00',
  'America/Matamoros': 'UTC -05:00',
  'America/Mazatlan': 'UTC -06:00',
  'America/Merida': 'UTC -05:00',
  'America/Mexico_City': 'UTC -05:00',
  'America/Monterrey': 'UTC -05:00',
  'America/Ojinaga': 'UTC -06:00',
  'America/Tijuana': 'UTC -07:00',
  'Pacific/Chuuk': 'UTC +10:00',
  'Pacific/Kosrae': 'UTC +11:00',
  'Pacific/Pohnpei': 'UTC +11:00',
  'Europe/Chisinau': 'UTC +03:00',
  'Europe/Monaco': 'UTC +02:00',
  'Asia/Choibalsan': 'UTC +08:00',
  'Asia/Hovd': 'UTC +07:00',
  'Asia/Ulaanbaatar': 'UTC +08:00',
  'Europe/Podgorica': 'UTC +02:00',
  'America/Montserrat': 'UTC -04:00',
  'Africa/Casablanca': 'UTC +01:00',
  'Africa/Maputo': 'UTC +02:00',
  'Asia/Yangon': 'UTC +06:30',
  'Africa/Windhoek': 'UTC +02:00',
  'Pacific/Nauru': 'UTC +12:00',
  'Asia/Kathmandu': 'UTC +05:45',
  'Europe/Amsterdam': 'UTC +02:00',
  'Pacific/Noumea': 'UTC +11:00',
  'Pacific/Auckland': 'UTC +12:00',
  'Pacific/Chatham': 'UTC +12:45',
  'America/Managua': 'UTC -06:00',
  'Africa/Niamey': 'UTC +01:00',
  'Africa/Lagos': 'UTC +01:00',
  'Pacific/Niue': 'UTC -11:00',
  'Pacific/Norfolk': 'UTC +11:00',
  'Asia/Pyongyang': 'UTC +09:00',
  'Pacific/Saipan': 'UTC +10:00',
  'Europe/Oslo': 'UTC +02:00',
  'Asia/Muscat': 'UTC +04:00',
  'Asia/Karachi': 'UTC +05:00',
  'Pacific/Palau': 'UTC +09:00',
  'Asia/Gaza': 'UTC +03:00',
  'Asia/Hebron': 'UTC +03:00',
  'America/Panama': 'UTC -05:00',
  'Pacific/Bougainville': 'UTC +11:00',
  'Pacific/Port_Moresby': 'UTC +10:00',
  'America/Asuncion': 'UTC -04:00',
  'America/Lima': 'UTC -05:00',
  'Asia/Manila': 'UTC +08:00',
  'Pacific/Pitcairn': 'UTC -08:00',
  'Europe/Warsaw': 'UTC +02:00',
  'Atlantic/Azores': 'UTC',
  'Atlantic/Madeira': 'UTC +01:00',
  'Europe/Lisbon': 'UTC +01:00',
  'America/Puerto_Rico': 'UTC -04:00',
  'Asia/Qatar': 'UTC +03:00',
  'Africa/Brazzaville': 'UTC +01:00',
  'Indian/Reunion': 'UTC +04:00',
  'Europe/Bucharest': 'UTC +03:00',
  'Asia/Anadyr': 'UTC +12:00',
  'Asia/Barnaul': 'UTC +07:00',
  'Asia/Chita': 'UTC +09:00',
  'Asia/Irkutsk': 'UTC +08:00',
  'Asia/Kamchatka': 'UTC +12:00',
  'Asia/Khandyga': 'UTC +09:00',
  'Asia/Krasnoyarsk': 'UTC +07:00',
  'Asia/Magadan': 'UTC +11:00',
  'Asia/Novokuznetsk': 'UTC +07:00',
  'Asia/Novosibirsk': 'UTC +07:00',
  'Asia/Omsk': 'UTC +06:00',
  'Asia/Sakhalin': 'UTC +11:00',
  'Asia/Srednekolymsk': 'UTC +11:00',
  'Asia/Tomsk': 'UTC +07:00',
  'Asia/Ust-Nera': 'UTC +10:00',
  'Asia/Vladivostok': 'UTC +10:00',
  'Asia/Yakutsk': 'UTC +09:00',
  'Asia/Yekaterinburg': 'UTC +05:00',
  'Europe/Astrakhan': 'UTC +04:00',
  'Europe/Kaliningrad': 'UTC +02:00',
  'Europe/Kirov': 'UTC +03:00',
  'Europe/Moscow': 'UTC +03:00',
  'Europe/Samara': 'UTC +04:00',
  'Europe/Saratov': 'UTC +04:00',
  'Europe/Simferopol': 'UTC +03:00',
  'Europe/Ulyanovsk': 'UTC +04:00',
  'Europe/Volgograd': 'UTC +03:00',
  'Africa/Kigali': 'UTC +02:00',
  'America/St_Barthelemy': 'UTC -04:00',
  'Atlantic/St_Helena': 'UTC',
  'America/St_Kitts': 'UTC -04:00',
  'America/St_Lucia': 'UTC -04:00',
  'America/Marigot': 'UTC -04:00',
  'America/Miquelon': 'UTC -02:00',
  'America/St_Vincent': 'UTC -04:00',
  'Pacific/Apia': 'UTC +13:00',
  'Europe/San_Marino': 'UTC +02:00',
  'Africa/Sao_Tome': 'UTC +01:00',
  'Asia/Riyadh': 'UTC +03:00',
  'Africa/Dakar': 'UTC',
  'Europe/Belgrade': 'UTC +02:00',
  'Indian/Mahe': 'UTC +04:00',
  'Africa/Freetown': 'UTC',
  'Asia/Singapore': 'UTC +08:00',
  'America/Lower_Princes': 'UTC -04:00',
  'Europe/Bratislava': 'UTC +02:00',
  'Europe/Ljubljana': 'UTC +02:00',
  'Pacific/Guadalcanal': 'UTC +11:00',
  'Africa/Mogadishu': 'UTC +03:00',
  'Africa/Johannesburg': 'UTC +02:00',
  'Atlantic/South_Georgia': 'UTC -02:00',
  'Asia/Seoul': 'UTC +09:00',
  'Africa/Juba': 'UTC +03:00',
  'Africa/Ceuta': 'UTC +02:00',
  'Atlantic/Canary': 'UTC +01:00',
  'Europe/Madrid': 'UTC +02:00',
  'Asia/Colombo': 'UTC +05:30',
  'Africa/Khartoum': 'UTC +02:00',
  'America/Paramaribo': 'UTC -03:00',
  'Arctic/Longyearbyen': 'UTC +02:00',
  'Africa/Mbabane': 'UTC +02:00',
  'Europe/Stockholm': 'UTC +02:00',
  'Europe/Zurich': 'UTC +02:00',
  'Asia/Damascus': 'UTC +03:00',
  'Asia/Taipei': 'UTC +08:00',
  'Asia/Dushanbe': 'UTC +05:00',
  'Africa/Dar_es_Salaam': 'UTC +03:00',
  'Asia/Bangkok': 'UTC +07:00',
  'Africa/Lome': 'UTC',
  'Pacific/Fakaofo': 'UTC +13:00',
  'Pacific/Tongatapu': 'UTC +13:00',
  'America/Port_of_Spain': 'UTC -04:00',
  'Africa/Tunis': 'UTC +01:00',
  'Europe/Istanbul': 'UTC +03:00',
  'Asia/Ashgabat': 'UTC +05:00',
  'America/Grand_Turk': 'UTC -04:00',
  'Pacific/Funafuti': 'UTC +12:00',
  'America/St_Thomas': 'UTC -04:00',
  'Africa/Kampala': 'UTC +03:00',
  'Europe/Kiev': 'UTC +03:00',
  'Europe/Uzhgorod': 'UTC +03:00',
  'Europe/Zaporozhye': 'UTC +03:00',
  'Asia/Dubai': 'UTC +04:00',
  'Europe/London': 'UTC +01:00',
  'America/Adak': 'UTC -09:00',
  'America/Anchorage': 'UTC -08:00',
  'America/Boise': 'UTC -06:00',
  'America/Chicago': 'UTC -05:00',
  'America/Denver': 'UTC -06:00',
  'America/Detroit': 'UTC -04:00',
  'America/Indiana/Indianapolis': 'UTC -04:00',
  'America/Indiana/Knox': 'UTC -05:00',
  'America/Indiana/Marengo': 'UTC -04:00',
  'America/Indiana/Petersburg': 'UTC -04:00',
  'America/Indiana/Tell_City': 'UTC -05:00',
  'America/Indiana/Vevay': 'UTC -04:00',
  'America/Indiana/Vincennes': 'UTC -04:00',
  'America/Indiana/Winamac': 'UTC -04:00',
  'America/Juneau': 'UTC -08:00',
  'America/Kentucky/Louisville': 'UTC -04:00',
  'America/Kentucky/Monticello': 'UTC -04:00',
  'America/Los_Angeles': 'UTC -07:00',
  'America/Menominee': 'UTC -05:00',
  'America/Metlakatla': 'UTC -08:00',
  'America/New_York': 'UTC -04:00',
  'America/Nome': 'UTC -08:00',
  'America/North_Dakota/Beulah': 'UTC -05:00',
  'America/North_Dakota/Center': 'UTC -05:00',
  'America/North_Dakota/New_Salem': 'UTC -05:00',
  'America/Phoenix': 'UTC -07:00',
  'America/Sitka': 'UTC -08:00',
  'America/Yakutat': 'UTC -08:00',
  'Pacific/Honolulu': 'UTC -10:00',
  'Pacific/Midway': 'UTC -11:00',
  'Pacific/Wake': 'UTC +12:00',
  'America/Montevideo': 'UTC -03:00',
  'Asia/Samarkand': 'UTC +05:00',
  'Asia/Tashkent': 'UTC +05:00',
  'Pacific/Efate': 'UTC +11:00',
  'Europe/Vatican': 'UTC +02:00',
  'America/Caracas': 'UTC -04:00',
  'Asia/Ho_Chi_Minh': 'UTC +07:00',
  'Pacific/Wallis': 'UTC +12:00',
  'Africa/El_Aaiun': 'UTC +01:00',
  'Asia/Aden': 'UTC +03:00',
  'Africa/Lusaka': 'UTC +02:00',
  'Africa/Harare': 'UTC +02:00',
  'Etc/UTC': 'UTC +00:00',
} as const;

export const TIMEZONE_DISPLAY_LIST = [
  {label: '(UTC−11:00) Niue Time — Niue', ianaKey: 'Pacific/Niue'},
  {
    label: '(UTC−11:00) Samoa Standard Time — American Samoa',
    ianaKey: 'Pacific/Pago_Pago',
  },
  {label: '(UTC−10:00) Hawaii Time — Hawaii, USA', ianaKey: 'Pacific/Honolulu'},
  {
    label: '(UTC−10:00) Cook Island Time — Cook Islands',
    ianaKey: 'Pacific/Rarotonga',
  },
  {
    label: '(UTC−10:00) Tahiti Time — French Polynesia',
    ianaKey: 'Pacific/Tahiti',
  },
  {
    label: '(UTC−9:30) Marquesas Islands Time — French Polynesia',
    ianaKey: 'Pacific/Marquesas',
  },
  {label: '(UTC−9:00) Alaska Time — Alaska, USA', ianaKey: 'America/Anchorage'},
  {
    label: '(UTC−9:00) Gambier Islands Time — French Polynesia',
    ianaKey: 'Pacific/Gambier',
  },
  {
    label: '(UTC−8:00) Pacific Time — CA, OR, WA, USA; BC, Canada',
    ianaKey: 'America/Los_Angeles',
  },
  {
    label: '(UTC−8:00) Pitcairn Standard Time — Pitcairn Islands',
    ianaKey: 'Pacific/Pitcairn',
  },
  {
    label: '(UTC−7:00) Mountain Time — CO, MT, NM, UT, WY, USA; AB, Canada',
    ianaKey: 'America/Denver',
  },
  {
    label: '(UTC−7:00) Arizona Time (No DST) — Arizona, USA',
    ianaKey: 'America/Phoenix',
  },
  {
    label: '(UTC−6:00) Central Time — TX, IL, MN, USA; MB, ON, Canada',
    ianaKey: 'America/Chicago',
  },
  {
    label:
      '(UTC−6:00) Central America Time (No DST) — Belize, Costa Rica, El Salvador, Guatemala, Honduras, Nicaragua',
    ianaKey: 'America/Belize',
  },
  {
    label: '(UTC−6:00) Galápagos Time — Galápagos Islands',
    ianaKey: 'Pacific/Galapagos',
  },
  {
    label: '(UTC−5:00) Eastern Time — NY, FL, OH, USA; ON, QC, Canada',
    ianaKey: 'America/New_York',
  },
  {label: '(UTC−5:00) Colombia Time — Colombia', ianaKey: 'America/Bogota'},
  {label: '(UTC−5:00) Peru Time — Peru', ianaKey: 'America/Lima'},
  {label: '(UTC−5:00) Ecuador Time — Ecuador', ianaKey: 'America/Guayaquil'},
  {label: '(UTC−5:00) Cuba Time — Cuba', ianaKey: 'America/Havana'},
  {
    label: '(UTC−5:00) Jamaica Time (No DST) — Jamaica',
    ianaKey: 'America/Jamaica',
  },
  {
    label:
      '(UTC−4:00) Atlantic Time — Atlantic Canada; Puerto Rico; US Virgin Islands',
    ianaKey: 'America/Halifax',
  },
  {label: '(UTC−4:00) Venezuela Time — Venezuela', ianaKey: 'America/Caracas'},
  {label: '(UTC−4:00) Bolivia Time — Bolivia', ianaKey: 'America/La_Paz'},
  {label: '(UTC−4:00) Guyana Time — Guyana', ianaKey: 'America/Guyana'},
  {label: '(UTC−4:00) Amazon Time — Western Brazil', ianaKey: 'America/Manaus'},
  {
    label: '(UTC−4:00) Chile Time — Chile (mainland)',
    ianaKey: 'America/Santiago',
  },
  {label: '(UTC−4:00) Paraguay Time — Paraguay', ianaKey: 'America/Asuncion'},
  {
    label: '(UTC−3:30) Newfoundland Time — Newfoundland, Canada',
    ianaKey: 'America/St_Johns',
  },
  {
    label: '(UTC−3:00) Brasília Time — Most of Brazil',
    ianaKey: 'America/Sao_Paulo',
  },
  {
    label: '(UTC−3:00) Argentina Time — Argentina',
    ianaKey: 'America/Argentina/Buenos_Aires',
  },
  {label: '(UTC−3:00) Uruguay Time — Uruguay', ianaKey: 'America/Montevideo'},
  {label: '(UTC−3:00) Suriname Time — Suriname', ianaKey: 'America/Paramaribo'},
  {
    label: '(UTC−3:00) French Guiana Time — French Guiana',
    ianaKey: 'America/Cayenne',
  },
  {
    label: '(UTC−3:00) Falkland Islands Time — Falkland Islands',
    ianaKey: 'Atlantic/Stanley',
  },
  {
    label: '(UTC−2:00) Fernando de Noronha Time — Fernando de Noronha, Brazil',
    ianaKey: 'America/Noronha',
  },
  {
    label:
      '(UTC−2:00) South Georgia Time — South Georgia & South Sandwich Islands',
    ianaKey: 'Atlantic/South_Georgia',
  },
  {
    label: '(UTC−1:00) Azores Time — Azores, Portugal',
    ianaKey: 'Atlantic/Azores',
  },
  {
    label: '(UTC−1:00) Cape Verde Time — Cape Verde',
    ianaKey: 'Atlantic/Cape_Verde',
  },
  {
    label: '(UTC±0:00) Greenwich Mean Time — United Kingdom',
    ianaKey: 'Europe/London',
  },
  {label: '(UTC±0:00) Greenwich Mean Time — Ireland', ianaKey: 'Europe/Dublin'},
  {
    label: '(UTC±0:00) Greenwich Mean Time — Iceland',
    ianaKey: 'Atlantic/Reykjavik',
  },
  {
    label:
      '(UTC±0:00) Western European Time — Portugal, Canary Islands, Faroe Islands',
    ianaKey: 'Europe/Lisbon',
  },
  {
    label:
      '(UTC±0:00) GMT (No DST) — Ghana, Côte d\'Ivoire, Senegal, Gambia and more',
    ianaKey: 'Africa/Accra',
  },
  {
    label:
      '(UTC+1:00) Central European Time — France, Germany, Italy, Poland, Netherlands and more',
    ianaKey: 'Europe/Paris',
  },
  {
    label:
      '(UTC+1:00) West Africa Time (No DST) — Nigeria, Algeria, Angola, Cameroon, Niger and more',
    ianaKey: 'Africa/Lagos',
  },
  {
    label:
      '(UTC+2:00) Eastern European Time — Greece, Bulgaria, Romania, Finland, Estonia, Latvia, Lithuania and more',
    ianaKey: 'Europe/Athens',
  },
  {label: '(UTC+2:00) Israel Time — Israel', ianaKey: 'Asia/Jerusalem'},
  {
    label:
      '(UTC+2:00) South Africa Standard Time — South Africa, Lesotho, Eswatini',
    ianaKey: 'Africa/Johannesburg',
  },
  {
    label:
      '(UTC+2:00) Central Africa Time — Botswana, Rwanda, Zambia, Zimbabwe and more',
    ianaKey: 'Africa/Maputo',
  },
  {
    label: '(UTC+2:00) Kaliningrad Time — Kaliningrad, Russia',
    ianaKey: 'Europe/Kaliningrad',
  },
  {label: '(UTC+2:00) Egypt Standard Time — Egypt', ianaKey: 'Africa/Cairo'},
  {label: '(UTC+2:00) Sudan Time — Sudan', ianaKey: 'Africa/Khartoum'},
  {
    label:
      '(UTC+3:00) Moscow Standard Time — Russia (Moscow & western regions)',
    ianaKey: 'Europe/Moscow',
  },
  {label: '(UTC+3:00) Turkey Time — Turkey', ianaKey: 'Europe/Istanbul'},
  {
    label:
      '(UTC+3:00) Arabia Standard Time — Saudi Arabia, Iraq, Kuwait, Bahrain, Qatar, Yemen',
    ianaKey: 'Asia/Riyadh',
  },
  {label: '(UTC+3:00) Belarus Time — Belarus', ianaKey: 'Europe/Minsk'},
  {
    label:
      '(UTC+3:00) East Africa Time — Kenya, Ethiopia, Tanzania, Uganda, Somalia, Madagascar',
    ianaKey: 'Africa/Nairobi',
  },
  {label: '(UTC+3:30) Iran Time — Iran', ianaKey: 'Asia/Tehran'},
  {label: '(UTC+4:00) Gulf Standard Time — UAE, Oman', ianaKey: 'Asia/Dubai'},
  {label: '(UTC+4:00) Azerbaijan Time — Azerbaijan', ianaKey: 'Asia/Baku'},
  {label: '(UTC+4:00) Armenia Time — Armenia', ianaKey: 'Asia/Yerevan'},
  {
    label: '(UTC+4:00) Georgia Standard Time — Georgia',
    ianaKey: 'Asia/Tbilisi',
  },
  {label: '(UTC+4:00) Mauritius Time — Mauritius', ianaKey: 'Indian/Mauritius'},
  {label: '(UTC+4:00) Seychelles Time — Seychelles', ianaKey: 'Indian/Mahe'},
  {
    label: '(UTC+4:00) Réunion Time — Réunion, France',
    ianaKey: 'Indian/Reunion',
  },
  {label: '(UTC+4:30) Afghanistan Time — Afghanistan', ianaKey: 'Asia/Kabul'},
  {
    label: '(UTC+5:00) Pakistan Standard Time — Pakistan',
    ianaKey: 'Asia/Karachi',
  },
  {label: '(UTC+5:00) Uzbekistan Time — Uzbekistan', ianaKey: 'Asia/Tashkent'},
  {label: '(UTC+5:00) Tajikistan Time — Tajikistan', ianaKey: 'Asia/Dushanbe'},
  {
    label: '(UTC+5:00) Turkmenistan Time — Turkmenistan',
    ianaKey: 'Asia/Ashgabat',
  },
  {label: '(UTC+5:00) Maldives Time — Maldives', ianaKey: 'Indian/Maldives'},
  {
    label: '(UTC+5:00) Yekaterinburg Time — Yekaterinburg, Russia',
    ianaKey: 'Asia/Yekaterinburg',
  },
  {label: '(UTC+5:30) India Standard Time — India', ianaKey: 'Asia/Kolkata'},
  {
    label: '(UTC+5:30) Sri Lanka Standard Time — Sri Lanka',
    ianaKey: 'Asia/Colombo',
  },
  {label: '(UTC+5:45) Nepal Time — Nepal', ianaKey: 'Asia/Kathmandu'},
  {
    label: '(UTC+6:00) Bangladesh Standard Time — Bangladesh',
    ianaKey: 'Asia/Dhaka',
  },
  {label: '(UTC+6:00) Bhutan Time — Bhutan', ianaKey: 'Asia/Thimphu'},
  {label: '(UTC+6:00) Kazakhstan Time — Kazakhstan', ianaKey: 'Asia/Almaty'},
  {label: '(UTC+6:00) Kyrgyzstan Time — Kyrgyzstan', ianaKey: 'Asia/Bishkek'},
  {label: '(UTC+6:00) Omsk Time — Omsk, Russia', ianaKey: 'Asia/Omsk'},
  {label: '(UTC+6:30) Myanmar Time — Myanmar', ianaKey: 'Asia/Yangon'},
  {
    label: '(UTC+7:00) Indochina Time — Thailand, Vietnam, Cambodia, Laos',
    ianaKey: 'Asia/Bangkok',
  },
  {
    label:
      '(UTC+7:00) Western Indonesia Time — Jakarta, Sumatra, Java, Kalimantan',
    ianaKey: 'Asia/Jakarta',
  },
  {
    label: '(UTC+7:00) Krasnoyarsk Time — Krasnoyarsk, Russia',
    ianaKey: 'Asia/Krasnoyarsk',
  },
  {
    label: '(UTC+7:00) Christmas Island Time — Christmas Island',
    ianaKey: 'Indian/Christmas',
  },
  {
    label: '(UTC+8:00) China Standard Time — China, Hong Kong, Macau, Taiwan',
    ianaKey: 'Asia/Shanghai',
  },
  {
    label: '(UTC+8:00) Singapore Standard Time — Singapore',
    ianaKey: 'Asia/Singapore',
  },
  {label: '(UTC+8:00) Malaysia Time — Malaysia', ianaKey: 'Asia/Kuala_Lumpur'},
  {
    label: '(UTC+8:00) Philippine Standard Time — Philippines',
    ianaKey: 'Asia/Manila',
  },
  {label: '(UTC+8:00) Brunei Time — Brunei', ianaKey: 'Asia/Brunei'},
  {
    label: '(UTC+8:00) Central Indonesia Time — Bali, Sulawesi, Lombok',
    ianaKey: 'Asia/Makassar',
  },
  {
    label: '(UTC+8:00) Australian Western Standard Time — Western Australia',
    ianaKey: 'Australia/Perth',
  },
  {
    label: '(UTC+8:00) Ulaanbaatar Time — Mongolia',
    ianaKey: 'Asia/Ulaanbaatar',
  },
  {label: '(UTC+8:00) Irkutsk Time — Irkutsk, Russia', ianaKey: 'Asia/Irkutsk'},
  {
    label: '(UTC+8:30) North Korea Standard Time — North Korea',
    ianaKey: 'Asia/Pyongyang',
  },
  {
    label:
      '(UTC+8:45) Australian Central Western Standard Time — Eucla, Western Australia',
    ianaKey: 'Australia/Eucla',
  },
  {label: '(UTC+9:00) Japan Standard Time — Japan', ianaKey: 'Asia/Tokyo'},
  {
    label: '(UTC+9:00) Korea Standard Time — South Korea',
    ianaKey: 'Asia/Seoul',
  },
  {
    label: '(UTC+9:00) Eastern Indonesia Time — Papua, Maluku',
    ianaKey: 'Asia/Jayapura',
  },
  {label: '(UTC+9:00) East Timor Time — Timor-Leste', ianaKey: 'Asia/Dili'},
  {label: '(UTC+9:00) Palau Time — Palau', ianaKey: 'Pacific/Palau'},
  {label: '(UTC+9:00) Yakutsk Time — Yakutsk, Russia', ianaKey: 'Asia/Yakutsk'},
  {
    label: '(UTC+9:30) Australian Central Time — South Australia',
    ianaKey: 'Australia/Adelaide',
  },
  {
    label:
      '(UTC+9:30) Australian Central Standard Time (No DST) — Northern Territory',
    ianaKey: 'Australia/Darwin',
  },
  {
    label: '(UTC+10:00) Australian Eastern Standard Time (No DST) — Queensland',
    ianaKey: 'Australia/Brisbane',
  },
  {
    label: '(UTC+10:00) Australian Eastern Time — NSW, Victoria, Tasmania, ACT',
    ianaKey: 'Australia/Sydney',
  },
  {
    label: '(UTC+10:00) Papua New Guinea Time — Papua New Guinea',
    ianaKey: 'Pacific/Port_Moresby',
  },
  {
    label:
      '(UTC+10:00) Chamorro Standard Time — Guam; Northern Mariana Islands',
    ianaKey: 'Pacific/Guam',
  },
  {
    label: '(UTC+10:00) Vladivostok Time — Vladivostok, Russia',
    ianaKey: 'Asia/Vladivostok',
  },
  {
    label: '(UTC+10:30) Lord Howe Island Time — Lord Howe Island, Australia',
    ianaKey: 'Australia/Lord_Howe',
  },
  {
    label: '(UTC+11:00) Solomon Islands Time — Solomon Islands',
    ianaKey: 'Pacific/Guadalcanal',
  },
  {label: '(UTC+11:00) Vanuatu Time — Vanuatu', ianaKey: 'Pacific/Efate'},
  {
    label: '(UTC+11:00) New Caledonia Time — New Caledonia, France',
    ianaKey: 'Pacific/Noumea',
  },
  {
    label: '(UTC+11:00) Sakhalin Time — Sakhalin, Russia',
    ianaKey: 'Asia/Sakhalin',
  },
  {
    label: '(UTC+11:00) Magadan Time — Magadan, Russia',
    ianaKey: 'Asia/Magadan',
  },
  {
    label: '(UTC+11:00) Norfolk Island Time — Norfolk Island, Australia',
    ianaKey: 'Pacific/Norfolk',
  },
  {
    label: '(UTC+12:00) New Zealand Time — New Zealand',
    ianaKey: 'Pacific/Auckland',
  },
  {label: '(UTC+12:00) Fiji Time — Fiji', ianaKey: 'Pacific/Fiji'},
  {
    label: '(UTC+12:00) Marshall Islands Time — Marshall Islands',
    ianaKey: 'Pacific/Majuro',
  },
  {label: '(UTC+12:00) Nauru Time — Nauru', ianaKey: 'Pacific/Nauru'},
  {label: '(UTC+12:00) Tuvalu Time — Tuvalu', ianaKey: 'Pacific/Funafuti'},
  {
    label: '(UTC+12:00) Kiribati Gilbert Islands Time — Kiribati',
    ianaKey: 'Pacific/Tarawa',
  },
  {
    label: '(UTC+12:00) Kamchatka Time — Kamchatka, Russia',
    ianaKey: 'Asia/Kamchatka',
  },
  {
    label: '(UTC+12:45) Chatham Islands Time — Chatham Islands, New Zealand',
    ianaKey: 'Pacific/Chatham',
  },
  {label: '(UTC+13:00) Tonga Time — Tonga', ianaKey: 'Pacific/Tongatapu'},
  {label: '(UTC+13:00) Samoa Standard Time — Samoa', ianaKey: 'Pacific/Apia'},
  {label: '(UTC+13:00) Tokelau Time — Tokelau', ianaKey: 'Pacific/Fakaofo'},
  {
    label: '(UTC+13:00) Phoenix Islands Time — Kiribati (Phoenix Islands)',
    ianaKey: 'Pacific/Enderbury',
  },
  {
    label: '(UTC+14:00) Line Islands Time — Kiribati (Line Islands)',
    ianaKey: 'Pacific/Kiritimati',
  },
] as const;

export const CONFERENCE_TYPE = [
  {key: 'OFFICE', label: 'Meeting Location'},
  {key: 'MICROSOFT_TEAMS', label: 'Microsoft Teams'},
  {key: 'GOOGLE_MEET', label: 'Google Meet'},
  {key: 'ZOOM', label: 'Zoom'},
] as const;

export const EVENT_OWNER = {
  USER_GOOGLE: 'USER_GOOGLE',
  USER_MICROSOFT: 'USER_MICROSOFT',
  SKILLATE: 'SKILLATE',
  SENSE_MEETINGS: 'SENSE_MEETINGS',
} as const;

export const CALENDAR_PROVIDER = {
  MICROSOFT: 'MICROSOFT',
  GOOGLE: 'GOOGLE',
  SKILLATE: 'SKILLATE',
  MICROSOFT_SERVER: 'MICROSOFT_SERVER',
} as const;

export const getCalendarProvider = (): string => {
  const state = window.senseStore.reduxStore.getState();
  const {accounts, crm} = state;
  const {user_info} = crm;
  if (!user_info || !user_info.organization) {
    return 'SKILLATE';
  }
  return user_info.organization.calendarProvider || 'SKILLATE';
};

export const getHostURL = (): string =>
  `${window.location.protocol}//${window.location.host}`;

export const getCurrentTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta'
    ? 'Asia/Kolkata'
    : Intl.DateTimeFormat().resolvedOptions().timeZone;
// Will delete this as we recieve the API from BE [ @Swatantra]

export const CRM_PLACE_HOLDERS = [
  {category: 'JOB', key: '{{job_name}}'},
  {category: 'JOB', key: '{{job_location}}'},
  {category: 'JOB', key: '{{job_team_creator_position}}'},
  {category: 'JOB', key: '{{job_id}}'},
  {category: 'JOB', key: '{{job_team_hiring_manager_first_name}}'},
  {category: 'JOB', key: '{{job_sub_department}}'},
  {category: 'JOB', key: '{{job_team_hiring_manager_position}}'},
  {category: 'JOB', key: '{{job_team_creator_full_name}}'},
  {category: 'JOB', key: '{{job_team_creator_first_name}}'},
  {category: 'JOB', key: '{{job_team_recruiter_contact}}'},
  {category: 'JOB', key: '{{job_team_creator_email}}'},
  {category: 'JOB', key: '{{job_team_recruiter_email}}'},
  {category: 'JOB', key: '{{job_team_hiring_manager_email}}'},
  {category: 'JOB', key: '{{job_team_recruiter_full_name}}'},
  {category: 'JOB', key: '{{job_team_recruiter_position}}'},
  {category: 'JOB', key: '{{job_team_recruiter_first_name}}'},
  {category: 'JOB', key: '{{job_team_creator_contact}}'},
  {category: 'JOB', key: '{{job_department}}'},
  {category: 'JOB', key: '{{job_department_l1}}'},
  {category: 'JOB', key: '{{job_department_l2}}'},
  {category: 'JOB', key: '{{job_department_l3}}'},
  {category: 'JOB', key: '{{job_department_l4}}'},
  {category: 'JOB', key: '{{job_department_l5}}'},
  {category: 'JOB', key: '{{job_department_lowest}}'},
  {category: 'JOB', key: '{{job_grade_l1}}'},
  {category: 'JOB', key: '{{job_grade_l2}}'},
  {category: 'JOB', key: '{{job_grade_l3}}'},
  {category: 'JOB', key: '{{job_grade_l4}}'},
  {category: 'JOB', key: '{{job_grade_l5}}'},
  {category: 'JOB', key: '{{job_grade_lowest}}'},
  {category: 'JOB', key: '{{job_type}}'},
  {category: 'JOB', key: '{{grade}}'},
  {category: 'JOB', key: '{{office_location}}'},
  {category: 'JOB', key: '{{office_city}}'},
  {category: 'JOB', key: '{{office_state}}'},
  {category: 'JOB', key: '{{office_country}}'},
  {category: 'JOB', key: '{{office_pincode}}'},
  {category: 'JOB', key: '{{job_code}}'},

  {category: 'CANDIDATE', key: '{{candidate_full_name}}'},
  {category: 'CANDIDATE', key: '{{candidate_current_position}}'},
  {category: 'CANDIDATE', key: '{{candidate_current_company}}'},
  {category: 'CANDIDATE', key: '{{candidate_email_id}}'},
  {category: 'CANDIDATE', key: '{{candidate_phone_number}}'},
  {category: 'CANDIDATE', key: '{{candidate_current_location}}'},
  {category: 'CANDIDATE', key: '{{candidate_first_name}}'},

  {category: 'ORGANIZATION', key: '{{organization_name}}'},

  {category: 'INTERVIEW', key: '{{interview_date_time}}'},
  {category: 'INTERVIEW', key: '{{interview_location}}'},
  {category: 'INTERVIEW', key: '{{conference_link}}'},
  {category: 'INTERVIEW', key: '{{conference_html}}'},
  {category: 'INTERVIEW', key: '{{round_name}}'},

  {category: 'CHATBOT', key: '{{chatbot_url}}'},

  {category: 'EMAIL', key: '{{sender_full_name}}'},
  {category: 'EMAIL', key: '{{sender_first_name}}'},
  {category: 'EMAIL', key: '{{sender_email_id}}'},
  {category: 'EMAIL', key: '{{sender_signature}}'},

  {category: 'CANDIDATE', key: '{{form_link}}'},
  {category: 'OFFER_LETTER', key: '{{offer_letter_url}}'},
  {category: 'CANDIDATE_FEEDBACK', key: '{{candidate_feedback_url}}'},
  {
    category: 'HIRING_MANAGER_FEEDBACK_URL',
    key: '{{hiring_manager_feedback_url}}',
  },

  {category: 'EMPLOYEE', key: '{{employee_full_name}}'},
  {category: 'EMPLOYEE', key: '{{employee_first_name}}'},
  {category: 'EMPLOYEE', key: '{{employee_email_id}}'},

  {category: 'FORM', key: '{{form_link}}'},

  {category: 'RECEIVER', key: '{{receiver_first_name}}'},
  {category: 'RECEIVER', key: '{{receiver_full_name}}'},
  {category: 'RECEIVER', key: '{{receiver_email_id}}'},

  {category: 'QUICK_MEETINGS', key: '{{session_link}}'},
] as const;

export const PLACEHOLDER_LIST = [
  {
    name: 'JOB',
    tooltip: '',
    placeHolders: [
      '{{job_name}}',
      '{{job_location}}',
      '{{job_team_creator_position}}',
      '{{job_id}}',
      '{{job_team_hiring_manager_first_name}}',
      '{{job_sub_department}}',
      '{{job_team_hiring_manager_position}}',
      '{{job_team_creator_full_name}}',
      '{{job_team_creator_first_name}}',
      '{{job_team_recruiter_contact}}',
      '{{job_team_creator_email}}',
      '{{job_team_recruiter_email}}',
      '{{job_team_hiring_manager_email}}',
      '{{job_team_recruiter_full_name}}',
      '{{job_team_recruiter_position}}',
      '{{job_team_recruiter_first_name}}',
      '{{job_team_creator_contact}}',
      '{{job_department}}',
      '{{job_department_l1}}',
      '{{job_department_l2}}',
      '{{job_department_l3}}',
      '{{job_department_l4}}',
      '{{job_department_l5}}',
      '{{job_department_lowest}}',
      '{{job_grade_l1}}',
      '{{job_grade_l2}}',
      '{{job_grade_l3}}',
      '{{job_grade_l4}}',
      '{{job_grade_l5}}',
      '{{job_grade_lowest}}',
      '{{job_type}}',
      '{{grade}}',
      '{{office_location}}',
      '{{office_city}}',
      '{{office_state}}',
      '{{office_country}}',
      '{{office_pincode}}',
      '{{job_code}}',
    ],
  },
  {
    name: 'CANDIDATE',
    tooltip: '',
    placeHolders: [
      '{{candidate_full_name}}',
      '{{candidate_current_position}}',
      '{{candidate_current_company}}',
      '{{candidate_email_id}}',
      '{{candidate_phone_number}}',
      '{{candidate_current_location}}',
      '{{candidate_first_name}}',
      '{{form_link}}',
    ],
  },
  {
    name: 'ORGANIZATION',
    tooltip: '',
    placeHolders: ['{{organization_name}}'],
  },
  {
    name: 'INTERVIEW',
    tooltip: '',
    placeHolders: [
      '{{interview_date_time}}',
      '{{interview_location}}',
      '{{conference_link}}',
      '{{conference_html}}',
      '{{round_name}}',
    ],
  },
  {
    name: 'CHATBOT',
    tooltip: '',
    placeHolders: ['{{chatbot_url}}'],
  },
  {
    name: 'EMAIL',
    tooltip: '',
    placeHolders: [
      '{{sender_full_name}}',
      '{{sender_first_name}}',
      '{{sender_email_id}}',
      '{{sender_signature}}',
    ],
  },
  {
    name: 'OFFER_LETTER',
    tooltip: '',
    placeHolders: ['{{offer_letter_url}}'],
  },
  {
    name: 'CANDIDATE_FEEDBACK',
    tooltip: '',
    placeHolders: ['{{candidate_feedback_url}}'],
  },
  {
    name: 'HIRING_MANAGER_FEEDBACK_URL',
    tooltip: '',
    placeHolders: ['{{hiring_manager_feedback_url}}'],
  },
  {
    name: 'EMPLOYEE',
    tooltip: '',
    placeHolders: [
      '{{employee_full_name}}',
      '{{employee_first_name}}',
      '{{employee_email_id}}',
    ],
  },
  {
    name: 'FORM',
    tooltip: '',
    placeHolders: ['{{form_link}}'],
  },
  {
    name: 'RECEIVER',
    tooltip: '',
    placeHolders: [
      '{{receiver_first_name}}',
      '{{receiver_full_name}}',
      '{{receiver_email_id}}',
    ],
  },
  {
    name: 'QUICK_MEETINGS',
    tooltip: '',
    placeHolders: ['{{session_link}}'],
  },
] as const;

export const hasCompletedAllStepsForMandatoryStage = (
  stageActionStatus: string,
  mandatory: boolean = false,
): boolean => {
  if (!mandatory) {
    return true;
  }
  switch (stageActionStatus) {
    case 'MOVE_NEXT_STAGE':
    case 'INTERVIEW_COMPLETED':
    case 'REVIEW_COMPLETED':
    case 'FORM_SUBMITTED':
    case 'INTERNAL_FORM_SUBMITTED':
    case 'ASSESSMENT_COMPLETED':
    case 'OFFER_ACCEPTED_BY_CANDIDATE':
    case 'COMPLETED':
      return true;
    default:
      return false;
  }
};

export const getCandidateExperienceText = (
  yearsOfExperience: number,
): string => {
  const years = `${Math.floor(yearsOfExperience)} years`;
  const totalInMonths = Math.round(yearsOfExperience * 12);
  const months = `${totalInMonths % 12} months`;
  return yearsOfExperience > 0 && totalInMonths > 0
    ? years + ' ' + months
    : yearsOfExperience > 0
    ? years
    : totalInMonths > 0
    ? months
    : 'N/A';
};

export const getApiPrefix = (role: string): string => {
  return role === 'AGENCY' ? 'trmapi/agency' : '/trmapi';
};

export const getBaseUrl = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    return `${parsedUrl.protocol}//${parsedUrl.host}`;
  } catch (error: any) {
    console.error('Invalid URL:', error);
    return null;
  }
};

export const formatExperirnceDate = (
  month: number,
  year: string,
  t: TranslationFunction,
  makeKey: MakeKeyFunction,
): string => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'April',
    'May',
    'June',
    'July',
    'August',
    'Sept',
    'October',
    'Nov',
    'Dec',
  ];

  if (month === null || month === -1) {
    return year || '';
  }
  // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
  const monthIndex = parseInt(month, 10);
  if (monthIndex >= 0 && monthIndex < 12) {
    return `${t(makeKey(monthNames[monthIndex]), monthNames[monthIndex])} ${
      year || ''
    }`;
  }
  return `${month} ${year || ''}`;
};

export const getCalendarDateWithTime = (momentDate: any, timeString: any) => {
  if (!momentDate) {
    return undefined;
  }
  if (!timeString) {
    return undefined;
  }
  const time = moment(timeString, 'hh:mmA');
  const date = new Date(
    `${momentDate.format('YYYY-MM-DD')}T${time.format('HH:mm:ss')}`,
  );

  return date;
};

const convertTo24HourFormat = (timeString: any) => {
  if (!timeString || !timeString.match(/(\d+:\d+)([APMapm]{2})/)) {
    return;
  }

  const [time, period] = timeString.match(/(\d+:\d+)([APMapm]{2})/).slice(1, 3);

  let [hour, minute] = time.split(':');
  hour = parseInt(hour, 10);

  if (period.toLowerCase() === 'pm' && hour !== 12) {
    hour += 12;
  } else if (period.toLowerCase() === 'am' && hour === 12) {
    hour = 0;
  }

  return hour * 60 + parseInt(minute, 10);
};

// @ts-expect-error - TS7030 - Not all code paths return a value.
export const isEndTimeEarlierThanStartTime = (startTime: any, endTime: any) => {
  // debugger;
  const startMinutes = convertTo24HourFormat(startTime);
  const endMinutes = convertTo24HourFormat(endTime);

  if (startMinutes !== null && endMinutes !== null) {
    // @ts-expect-error - TS18048 - 'startMinutes' is possibly 'undefined'. | TS18048 - 'endMinutes' is possibly 'undefined'.
    if (startMinutes < endMinutes) {
      return false;
      // @ts-expect-error - TS18048 - 'startMinutes' is possibly 'undefined'. | TS18048 - 'endMinutes' is possibly 'undefined'.
    } else if (startMinutes > endMinutes) {
      return true;
    }
  }
};

export const getCurrentLanguage = (): string => {
  return typeof navigator !== 'undefined' && navigator.language
    ? navigator.language.split(/[-_]/)[0]
    : 'en';
};

export function convertToLowerCase(str: string): string {
  return str && typeof str === 'string' ? str.toLowerCase() : str;
}

/**
 * Converts a date and time to a moment timezone
 *
 * @param {string|Object} date - Date as string or moment object
 * @param {string} timeString - Time in HH:mm or hh:mmA format
 * @param {string} timeZone - Timezone string
 * @returns {Object|undefined} - Moment timezone object or undefined on error
 */

export const getDateTimezone = (date: any, timeString: any, timeZone: any) => {
  try {
    // Handle case where date is not provided
    if (!date) {
      return undefined;
    }

    // Convert to moment object if it's not already
    const momentDate = moment.isMoment(date) ? date : moment(date);

    // Validate momentDate is valid
    if (!momentDate.isValid()) {
      console.warn('Invalid date provided to getDateTimezone:', date);
      return undefined;
    }

    // Handle case where time is not provided
    if (!timeString) {
      return undefined;
    }

    // Try to parse time using multiple formats
    const time = moment(timeString, ['HH:mm', 'hh:mm A', 'hh:mmA']);

    // Validate time is valid
    if (!time.isValid()) {
      console.warn('Invalid time provided to getDateTimezone:', timeString);
      return undefined;
    }

    // Combine date and time in the specified timezone
    // @ts-expect-error - TS2339 - Property 'tz' does not exist on type 'typeof moment'.
    const convertDate = moment.tz(
      `${momentDate.format('YYYY-MM-DD')}T${time.format('HH:mm:ss')}`,
      // Fallback to local timezone if not provided
      // @ts-expect-error - TS2339 - Property 'tz' does not exist on type 'typeof moment'.
      timeZone || moment.tz.guess(),
    );

    // Final validation
    if (!convertDate.isValid()) {
      console.warn('Failed to create valid datetime with:', {
        date,
        timeString,
        timeZone,
      });
      return undefined;
    }

    return convertDate;
  } catch (error: any) {
    console.error('Error in getDateTimezone:', error);
    console.error('Input parameters:', {date, timeString, timeZone});
    return undefined;
  }
};

/**
 * Converts a GMT date to the user's local timezone
 *
 * @param {Date|string} date - The date to convert
 * @returns {Date|undefined} - Converted date in local timezone or undefined if invalid
 */
export const convertGMTtoUserLocal = (
  date: Date | string,
): Date | undefined => {
  try {
    if (!date) {
      console.warn('No date provided to convertGMTtoUserLocal');
      return undefined;
    }

    // Convert to string if it's not already
    const stringDate = date.toString();

    // Find GMT in the string
    const gmtIndex = stringDate.indexOf('GMT');
    if (gmtIndex === -1) {
      console.warn('GMT not found in date string:', stringDate);
      return undefined;
    }

    // Extract the GMT portion
    const gmtString = stringDate.substring(0, gmtIndex + 3);

    // Create new date in local timezone
    const localDate = new Date(gmtString);

    // Validate result
    if (isNaN(localDate.getTime())) {
      console.warn('Failed to create valid date from:', gmtString);
      return undefined;
    }

    return localDate;
  } catch (error: any) {
    console.error('Error in convertGMTtoUserLocal:', error);
    return undefined;
  }
};

export const ACCEPTED_FILE_TYPES = [
  '.jpeg',
  '.png',
  '.pdf',
  '.docx',
  '.xls',
  '.csv',
  '.mp4',
  '.mp3',
  '.xlsx',
  '.doc',
];
